import { MobXProviderContext } from "mobx-react";
import { FilterMatchMode } from "primereact/api";
import { Accordion, AccordionTab } from "primereact/accordion";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { MultiSelect } from "primereact/multiselect";
import { ProgressSpinner } from "primereact/progressspinner";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useState } from "react";
import { getErrorTitle, USER_GROUP_ADMIN } from "../../../constants/constants";
import { ROLE_TYPE_ADMIN, ROLE_TYPE_CAREGIVER, ROLE_TYPE_MHP, ROLE_TYPE_NURSE, ROLE_TYPE_PROVIDER } from "../../../constants/RegisterConstants";
import { useResponsive } from "../../../responsive/ResponsiveProvider";
import Unauthorized from "../../../shared/pages/Unauthorized";
import {
  dashboardPageContainerStyle,
  dashboardSectionCardStyle,
  renderDashboardHeader,
} from "../../dashboard/pages/dashboardStyles";
import {
  appAccentPanelStyle,
  appDataTableWrapperStyle,
  appDialogContentStyle,
  appDialogHeaderStyle,
  appDialogStyle,
  appWideDialogStyle,
  appMutedTextStyle,
  appNeutralPanelStyle,
  renderDialogFooter,
  renderSurfaceHeader,
} from "../../../components/general/uiSurfaceStyles";
import { BinderRule, BinderRuleChangeAlert, BinderRuleSnapshot, BinderRuleSource, BinderType, HOME_BINDER_SYSTEM_FOLDERS, RESIDENT_BINDER_SYSTEM_FOLDERS } from "../../../models/binder";
import { NurseDirectoryChange, NurseDirectoryEntry, NurseDirectoryRun, ProviderDirectoryChange, ProviderDirectoryDashboard, ProviderDirectoryEntry, ProviderDirectoryRun } from "../../../models/providerDirectory";
import { sanitizeRichHtml } from "../../../utils/securityUtils";
import FaxAuditHistoryPage from "../../document/pages/FaxAuditHistoryPage";

const AdminPage = () => {
  type AdminToolbarAction = "invites" | "metrics" | "activity" | "users" | "feedback" | "binder" | "providerDirectory" | "nurseDirectory" | "demo" | "fax";
  type CampaignTemplateType = "launch_features_news" | "downtime" | "provider_signup" | "rn_signup" | "caregiver_signup" | "reach_out_to_new_providers" | "custom";
  const toast = React.useRef<Toast>(null);
  const emailCampaignEditorRef = React.useRef<HTMLDivElement | null>(null);
  const emailCampaignFailureTableRef = React.useRef<any>(null);
  const mobile = useResponsive().isMobile;
  const { backendAPIStore, authStore } = useContext(MobXProviderContext);
  const [userGroups, setUserGroups] = useState<string[]>([]);
  const [adminUserList, setAdminUserList] = useState<any[]>([]);
  const [adminUserListLoading, setAdminUserListLoading] = useState(false);
  const [adminUserExcludePrefixes, setAdminUserExcludePrefixes] = useState("ravishankar");
  const [adminUserRoleFilter, setAdminUserRoleFilter] = useState("");
  const [adminUserRoleCounts, setAdminUserRoleCounts] = useState<Array<{ roleType: string; count: number }>>([]);
  const [adminUserDirectoryTotal, setAdminUserDirectoryTotal] = useState(0);
  const [adminUserExcludedCount, setAdminUserExcludedCount] = useState(0);
  const [totalSubscriptions, setTotalSubscriptions] = useState<any>({ subscriptions: [] });
  const [showAdminUserHomesDialog, setShowAdminUserHomesDialog] = useState(false);
  const [selectedAdminUserEmail, setSelectedAdminUserEmail] = useState("");
  const [adminUserHomeDetailsLoading, setAdminUserHomeDetailsLoading] = useState(false);
  const [customerFeedbacks, setCustomerFeedbacks] = useState<any[]>([]);
  const [customerFeedbacksLoading, setCustomerFeedbacksLoading] = useState(false);
  const [selectedCustomerFeedback, setSelectedCustomerFeedback] = useState<any | null>(null);
  const [customerFeedbackMessages, setCustomerFeedbackMessages] = useState<any[]>([]);
  const [customerFeedbackMessagesLoading, setCustomerFeedbackMessagesLoading] = useState(false);
  const [customerFeedbackReply, setCustomerFeedbackReply] = useState("");
  const [customerFeedbackReplyLoading, setCustomerFeedbackReplyLoading] = useState(false);
  const [platformInvites, setPlatformInvites] = useState<any[]>([]);
  const [platformInvitesLoading, setPlatformInvitesLoading] = useState(false);
  const [observabilitySummary, setObservabilitySummary] = useState<any | null>(null);
  const [observabilityLoading, setObservabilityLoading] = useState(false);
  const [observabilityRange, setObservabilityRange] = useState("1d");
  const [activityLogs, setActivityLogs] = useState<any | null>(null);
  const [activityLogsLoading, setActivityLogsLoading] = useState(false);
  const [activityLogRange, setActivityLogRange] = useState("1h");
  const [activityLogSearch, setActivityLogSearch] = useState("");
  const [auditEvents, setAuditEvents] = useState<any | null>(null);
  const [auditEventPages, setAuditEventPages] = useState<any[]>([]);
  const [auditEventPageIndex, setAuditEventPageIndex] = useState(0);
  const [auditEventsLoading, setAuditEventsLoading] = useState(false);
  const [auditEventRange, setAuditEventRange] = useState("1d");
  const [auditEventSearch, setAuditEventSearch] = useState("");
  const [auditEventExcludeText, setAuditEventExcludeText] = useState("ravishankar");
  const [auditEventType, setAuditEventType] = useState("");
  const [auditEventStatus, setAuditEventStatus] = useState("");
  const [showAdminList, setShowAdminList] = useState(false);
  const [adminUserHomeDetails, setAdminUserHomeDetails] = useState<any[]>([]);
  const [showCustomerFeedbacks, setShowCustomerFeedbacks] = useState(false);
  const campaignSignupUrl = window.location.host.toLowerCase().includes("onehubforcare")
    ? "https://www.onehubforcare.com/signup"
    : "https://www.afhhub.com/signup";
  const [activeAdminAction, setActiveAdminAction] = useState<AdminToolbarAction | null>(null);
  const [initializing, setInitializing] = useState(true);
  const [selectedBinderRuleType, setSelectedBinderRuleType] = useState<BinderType>(BinderType.RESIDENT);
  const [binderRules, setBinderRules] = useState<BinderRule[]>([]);
  const [binderRulesLoading, setBinderRulesLoading] = useState(false);
  const [binderRuleSources, setBinderRuleSources] = useState<BinderRuleSource[]>([]);
  const [binderRuleSourcesLoading, setBinderRuleSourcesLoading] = useState(false);
  const [binderRuleAlerts, setBinderRuleAlerts] = useState<BinderRuleChangeAlert[]>([]);
  const [binderRuleAlertsLoading, setBinderRuleAlertsLoading] = useState(false);
  const [runningBinderRuleMonitor, setRunningBinderRuleMonitor] = useState(false);
  const [showBinderRuleSnapshotDialog, setShowBinderRuleSnapshotDialog] = useState(false);
  const [binderRuleSnapshotsLoading, setBinderRuleSnapshotsLoading] = useState(false);
  const [binderRuleSnapshots, setBinderRuleSnapshots] = useState<BinderRuleSnapshot[]>([]);
  const [selectedBinderRuleSource, setSelectedBinderRuleSource] = useState<BinderRuleSource | null>(null);
  const [selectedBinderRuleSnapshot, setSelectedBinderRuleSnapshot] = useState<BinderRuleSnapshot | null>(null);
  const [selectedBinderRuleSnapshotLoading, setSelectedBinderRuleSnapshotLoading] = useState(false);
  const [showBinderRuleSourceDialog, setShowBinderRuleSourceDialog] = useState(false);
  const [savingBinderRuleSource, setSavingBinderRuleSource] = useState(false);
  const [binderRuleSourceForm, setBinderRuleSourceForm] = useState<Partial<BinderRuleSource>>({});
  const [showBinderRuleDialog, setShowBinderRuleDialog] = useState(false);
  const [savingBinderRule, setSavingBinderRule] = useState(false);
  const [binderRuleDialogMode, setBinderRuleDialogMode] = useState<"create" | "edit" | "version">("create");
  const [binderRuleForm, setBinderRuleForm] = useState<Partial<BinderRule>>({});
  const [providerDirectoryDashboard, setProviderDirectoryDashboard] = useState<ProviderDirectoryDashboard | null>(null);
  const [providerCurrentEntries, setProviderCurrentEntries] = useState<ProviderDirectoryEntry[]>([]);
  const [providerCurrentEntriesPageIndex, setProviderCurrentEntriesPageIndex] = useState(0);
  const [providerCurrentEntriesPageSize, setProviderCurrentEntriesPageSize] = useState(100);
  const [providerCurrentEntriesPageCache, setProviderCurrentEntriesPageCache] = useState<Record<number, ProviderDirectoryEntry[]>>({});
  const [providerCurrentEntriesNextTokens, setProviderCurrentEntriesNextTokens] = useState<Record<number, string>>({ 0: "" });
  const [providerCurrentEntriesHasMoreByPage, setProviderCurrentEntriesHasMoreByPage] = useState<Record<number, boolean>>({});
  const [providerDirectoryLoading, setProviderDirectoryLoading] = useState(false);
  const [providerDirectoryExporting, setProviderDirectoryExporting] = useState(false);
  const [providerDirectoryRunning, setProviderDirectoryRunning] = useState(false);
  const [nurseDirectoryRunning, setNurseDirectoryRunning] = useState(false);
  const [providerDirectoryReportRunning, setProviderDirectoryReportRunning] = useState(false);
  const [showProviderDirectoryChangeDialog, setShowProviderDirectoryChangeDialog] = useState(false);
  const [selectedProviderDirectoryChange, setSelectedProviderDirectoryChange] = useState<ProviderDirectoryChange | null>(null);
  const [providerCurrentEntriesFilters, setProviderCurrentEntriesFilters] = useState<any>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    facilityName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    facilityPOC: { value: null, matchMode: FilterMatchMode.CONTAINS },
    telephoneNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    speciality: { value: null, matchMode: FilterMatchMode.CONTAINS },
    formattedAddress: { value: null, matchMode: FilterMatchMode.CONTAINS },
    licensedBedCount: { value: null, matchMode: FilterMatchMode.CONTAINS },
    hasReports: { value: null, matchMode: FilterMatchMode.CONTAINS },
    locationCounty: { value: null, matchMode: FilterMatchMode.CONTAINS },
    reportsLocation: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [providerCurrentEntriesGlobalFilter, setProviderCurrentEntriesGlobalFilter] = useState("");
  const [nurseCurrentEntriesFilters, setNurseCurrentEntriesFilters] = useState<any>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    displayName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [nurseCurrentEntriesGlobalFilter, setNurseCurrentEntriesGlobalFilter] = useState("");
  const [showEmailCampaignDialog, setShowEmailCampaignDialog] = useState(false);
  const [sendingEmailCampaign, setSendingEmailCampaign] = useState(false);
  const [emailCampaignTemplateType, setEmailCampaignTemplateType] = useState<CampaignTemplateType>("launch_features_news");
  const [emailCampaignManualTo, setEmailCampaignManualTo] = useState("");
  const [emailCampaignSendToAll, setEmailCampaignSendToAll] = useState(false);
  const [emailCampaignRoleFilters, setEmailCampaignRoleFilters] = useState<string[]>([]);
  const [emailCampaignSubject, setEmailCampaignSubject] = useState("");
  const [emailCampaignIntro, setEmailCampaignIntro] = useState("");
  const [emailCampaignHtmlBody, setEmailCampaignHtmlBody] = useState("");
  const [emailCampaignError, setEmailCampaignError] = useState<string | null>(null);
  const [emailCampaignResult, setEmailCampaignResult] = useState<any | null>(null);
  const [emailCampaignDeliveries, setEmailCampaignDeliveries] = useState<any[]>([]);
  const [emailCampaignDeliveriesLoading, setEmailCampaignDeliveriesLoading] = useState(false);
  const [emailCampaignPreviewLoading, setEmailCampaignPreviewLoading] = useState(false);
  const [emailCampaignPreview, setEmailCampaignPreview] = useState<any | null>(null);
  const [emailCampaignHistoryLoading, setEmailCampaignHistoryLoading] = useState(false);
  const [emailCampaignHistory, setEmailCampaignHistory] = useState<any[]>([]);
  const [retryingCampaignId, setRetryingCampaignId] = useState<string | null>(null);
  const [requeueingUnattemptedCampaign, setRequeueingUnattemptedCampaign] = useState(false);
  const [emailCampaignUserLookup, setEmailCampaignUserLookup] = useState<any>(null);
  const [emailCampaignUserSuggestions, setEmailCampaignUserSuggestions] = useState<any[]>([]);
  const [emailCampaignSelectedUser, setEmailCampaignSelectedUser] = useState<any | null>(null);
  const [demoSchedulerLoading, setDemoSchedulerLoading] = useState(false);
  const [demoSlots, setDemoSlots] = useState<any[]>([]);
  const [demoFeatureOptions, setDemoFeatureOptions] = useState<string[]>([]);
  const [showDemoSlotDialog, setShowDemoSlotDialog] = useState(false);
  const [savingDemoSlot, setSavingDemoSlot] = useState(false);
  const [showDemoRegistrationsDialog, setShowDemoRegistrationsDialog] = useState(false);
  const [selectedDemoSlot, setSelectedDemoSlot] = useState<any | null>(null);
  const [generatingDemoFeatureNotes, setGeneratingDemoFeatureNotes] = useState(false);
  const [demoFeatureNotesTouched, setDemoFeatureNotesTouched] = useState(false);
  const [demoSlotForm, setDemoSlotForm] = useState<any>({
    slotId: "",
    slotDate: "",
    startTime: "",
    endTime: "",
    capacity: 5,
    status: "open",
    demoTitle: "",
    selectedFeatures: [],
    customFeatureNotes: "",
    meetingLink: "",
    notes: "",
  });

  const demoTimeOptions = React.useMemo(() => {
    const items: Array<{ label: string; value: string }> = [];
    for (let hour = 0; hour < 24; hour += 1) {
      for (let minute = 0; minute < 60; minute += 30) {
        const value = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
        const labelDate = new Date(2026, 7, 5, hour, minute, 0, 0);
        const label = new Intl.DateTimeFormat("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }).format(labelDate);
        items.push({ label, value });
      }
    }
    return items;
  }, []);

  const formatCalendarDateKey = (value: Date | null) => {
    if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
      return "";
    }
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
  };

  const parseCalendarDateKey = (value: string) => {
    const normalized = String(value || "").trim();
    if (!normalized) {
      return null;
    }
    const [year, month, day] = normalized.split("-").map((part) => Number(part));
    if (!year || !month || !day) {
      return null;
    }
    return new Date(year, month - 1, day, 12, 0, 0, 0);
  };

  useEffect(() => {
    const initPage = async () => {
      try {
        await backendAPIStore.init();
        const groups = authStore.getUserGroups();
        setUserGroups(groups);
        if (groups.includes(USER_GROUP_ADMIN)) {
          setPlatformInvitesLoading(true);
          const invites = await backendAPIStore.getPlatformInvites();
          setPlatformInvites(invites || []);
        }
      } catch (error: any) {
        toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
      } finally {
        setPlatformInvitesLoading(false);
        setInitializing(false);
      }
    };

    initPage();
  }, [authStore, backendAPIStore]);

  useEffect(() => {
    if (initializing || !userGroups.includes(USER_GROUP_ADMIN)) {
      return;
    }

    const syncBinderRules = async () => {
      setBinderRulesLoading(true);
      setBinderRuleSourcesLoading(true);
      setBinderRuleAlertsLoading(true);
      try {
        const [rules, sources, alerts] = await Promise.all([
          backendAPIStore.listBinderRules(selectedBinderRuleType),
          backendAPIStore.listBinderRuleSources(selectedBinderRuleType),
          backendAPIStore.listBinderRuleChangeAlerts(selectedBinderRuleType),
        ]);
        setBinderRules(rules || []);
        setBinderRuleSources(sources || []);
        setBinderRuleAlerts(alerts || []);
      } catch (error: any) {
        toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load binder rules.", life: 3000 });
      } finally {
        setBinderRulesLoading(false);
        setBinderRuleSourcesLoading(false);
        setBinderRuleAlertsLoading(false);
      }
    };

    void syncBinderRules();
  }, [backendAPIStore, initializing, selectedBinderRuleType, userGroups]);

  useEffect(() => {
    if (activeAdminAction !== "providerDirectory") {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      void resetProviderCurrentEntriesPagination(providerCurrentEntriesPageSize);
    }, 250);

    return () => window.clearTimeout(timeoutId);
  }, [
    activeAdminAction,
    providerCurrentEntriesGlobalFilter,
    providerCurrentEntriesPageSize,
    providerCurrentEntriesFilters?.facilityPOC?.value,
    providerCurrentEntriesFilters?.telephoneNumber?.value,
    providerCurrentEntriesFilters?.speciality?.value,
    providerCurrentEntriesFilters?.formattedAddress?.value,
    providerCurrentEntriesFilters?.licensedBedCount?.value,
    providerCurrentEntriesFilters?.hasReports?.value,
  ]);

  useEffect(() => {
    if (!showEmailCampaignDialog || !emailCampaignEditorRef.current) {
      return;
    }

    if (emailCampaignEditorRef.current.innerHTML !== emailCampaignHtmlBody) {
      emailCampaignEditorRef.current.innerHTML = emailCampaignHtmlBody || "";
    }
  }, [emailCampaignHtmlBody, showEmailCampaignDialog]);

  useEffect(() => {
    if (!showEmailCampaignDialog) {
      return;
    }

    void ensureAdminUserDirectoryLoaded();
  }, [showEmailCampaignDialog]);

  const EMAIL_CAMPAIGN_TEMPLATES: Record<CampaignTemplateType, { label: string; subject: string; intro: string; htmlBody: string; }> = {
    launch_features_news: {
      label: "Launch Features News",
      subject: "AFH Hub Product Update",
      intro: "Share a polished update about recently launched AFH Hub improvements.",
      htmlBody: `
        <p>We are excited to share a few new AFH Hub improvements now available in your workspace.</p>
        <ul>
          <li><strong>What is new:</strong> Add your feature highlights here.</li>
          <li><strong>Why it matters:</strong> Explain how the update saves time or reduces manual work.</li>
          <li><strong>Where to find it:</strong> Point users to the page, workflow, or role that now supports it.</li>
        </ul>
        <p>Thank you for building with us. We will keep shipping improvements that make AFH work easier to manage.</p>
      `.trim(),
    },
    downtime: {
      label: "Downtime",
      subject: "AFH Hub Scheduled Maintenance Notice",
      intro: "Send a clear service notice with timing, impact, and next steps.",
      htmlBody: `
        <p>AFH Hub will have scheduled maintenance during the window below.</p>
        <table style="width:100%;border-collapse:collapse;">
          <tbody>
            <tr><td style="padding:8px;border:1px solid #d9e8f5;"><strong>Window</strong></td><td style="padding:8px;border:1px solid #d9e8f5;">Add date and time here</td></tr>
            <tr><td style="padding:8px;border:1px solid #d9e8f5;"><strong>Expected impact</strong></td><td style="padding:8px;border:1px solid #d9e8f5;">Describe what may be unavailable</td></tr>
            <tr><td style="padding:8px;border:1px solid #d9e8f5;"><strong>Preparation</strong></td><td style="padding:8px;border:1px solid #d9e8f5;">Share any steps users should take before the window</td></tr>
          </tbody>
        </table>
        <p>We appreciate your patience while we complete this work.</p>
      `.trim(),
    },
    provider_signup: {
      label: "Provider Signup",
      subject: "AFH Hub for Providers",
      intro: "Short provider summary with a signup link.",
      htmlBody: `
        <p>AFH Hub helps providers keep operations, resident records, and compliance work in one place.</p>
        <ul>
          <li>Manage homes, staff, and resident access from one dashboard.</li>
          <li>Create care plans, track eMAR, and organize documents.</li>
          <li>Handle billing, reminders, and website setup in one workflow.</li>
        </ul>
        <p><a href="${campaignSignupUrl}" target="_blank" rel="noreferrer">Create your account</a></p>
      `.trim(),
    },
    rn_signup: {
      label: "RN Signup",
      subject: "AFH Hub for Registered Nurses",
      intro: "Short RN summary with a signup link.",
      htmlBody: `
        <p>AFH Hub gives RNs a focused workspace for shared resident care, assessments, and delegation support.</p>
        <ul>
          <li>Review shared residents and complete assessments faster.</li>
          <li>Manage delegation workflows and nurse documentation in one place.</li>
          <li>Support medication and care-plan oversight with fewer manual steps.</li>
        </ul>
        <p><a href="${campaignSignupUrl}" target="_blank" rel="noreferrer">Create your account</a></p>
      `.trim(),
    },
    caregiver_signup: {
      label: "Caregiver Signup",
      subject: "AFH Hub for Caregivers",
      intro: "Short caregiver summary with a signup link.",
      htmlBody: `
        <p>AFH Hub helps caregivers stay organized with the daily tools they use most.</p>
        <ul>
          <li>See assigned residents and complete charting in one place.</li>
          <li>Use eMAR, daily notes, incident reports, and behavior tracking quickly.</li>
          <li>Stay aligned with the care plan without extra paper steps.</li>
        </ul>
        <p><a href="${campaignSignupUrl}" target="_blank" rel="noreferrer">Create your account</a></p>
      `.trim(),
    },
    reach_out_to_new_providers: {
      label: "Reach Out to New Providers",
      subject: "A quick check-in from the AFH Hub team",
      intro: "A friendly introduction for new adult family home providers.",
      htmlBody: `
        <p>We wanted to check in and see whether you need any assistance getting started with AFH Hub.</p>
        <p>AFH Hub helps your care team spend less time on repetitive paperwork and more time on care:</p>
        <ul>
          <li><strong>Faster care-plan documents:</strong> Create first drafts for negotiated care plans, assessments, delegation forms, and preliminary service plans in minutes instead of hours.</li>
          <li><strong>Behavior tracking &amp; reports:</strong> Capture CBHS/IBSS observations daily and prepare monthly reports in seconds.</li>
          <li><strong>eMAR without pharmacy delays:</strong> Import MAR sheets, build medication lists, compare changes, and start charting faster.</li>
          <li><strong>Clearer daily-care documentation:</strong> Track ADLs, support levels, and care actions in one resident-centered workflow, then export reports when needed.</li>
          <li><strong>Connected resident workflows:</strong> Keep resident records, care-plan details, reminders, documents, and care-team activity organized together.</li>
          <li><strong>Launch your facility website quickly:</strong> Publish and update a professional website without separate tools or complicated setup.</li>
        </ul>
        <p>If you would prefer to reach out directly, email me (Ravi Shankar) at <a href="mailto:ravishankar03077@gmail.com">ravishankar03077@gmail.com</a>.</p>
        <p>If you have questions or would like a walkthrough, <a href="${window.location.origin}/book-demo" target="_blank" rel="noreferrer">book a demo</a> and our team will be happy to help.</p>
      `.trim(),
    },
    custom: {
      label: "Custom",
      subject: "",
      intro: "Write a custom AFH Hub email using the branded shell and preview below.",
      htmlBody: `<p>Start your message here.</p>`,
    },
  };

  const emailCampaignRoleOptions = [
    { label: "Providers", value: ROLE_TYPE_PROVIDER },
    { label: "Caregivers", value: ROLE_TYPE_CAREGIVER },
    { label: "Nurses", value: ROLE_TYPE_NURSE },
  ];

  const getCognitoUserAttribute = (user: any, attributeName: string) =>
    user?.Attributes?.find((attr: any) => attr?.Name === attributeName)?.Value || "";

  const applyEmailCampaignTemplate = (templateType: CampaignTemplateType) => {
    const template = EMAIL_CAMPAIGN_TEMPLATES[templateType];
    setEmailCampaignTemplateType(templateType);
    setEmailCampaignSubject(template.subject);
    setEmailCampaignIntro(template.intro);
    setEmailCampaignHtmlBody(template.htmlBody);
    setEmailCampaignError(null);
  };

  const openEmailCampaignDialog = () => {
    applyEmailCampaignTemplate("launch_features_news");
    setEmailCampaignManualTo("");
    setEmailCampaignSendToAll(false);
    setEmailCampaignRoleFilters([]);
    setEmailCampaignResult(null);
    setEmailCampaignDeliveries([]);
    setEmailCampaignPreview(null);
    setEmailCampaignSelectedUser(null);
    setEmailCampaignUserLookup(null);
    setEmailCampaignUserSuggestions([]);
    setShowEmailCampaignDialog(true);
    void loadEmailCampaignHistory();
  };

  const getManualCampaignEmails = () => {
    const selectedUserEmail = String(getCognitoUserAttribute(emailCampaignSelectedUser, "email") || "").trim().toLowerCase();
    return Array.from(new Set(
      [
        ...emailCampaignManualTo
          .split(/[\n,;]+/)
          .map((value) => String(value || "").trim().toLowerCase())
          .filter(Boolean),
        selectedUserEmail,
      ].filter(Boolean),
    ));
  };

  const appendEmailCampaignRecipient = (email: string) => {
    const normalizedEmail = String(email || "").trim().toLowerCase();
    if (!normalizedEmail) {
      return;
    }

    const nextEmails = Array.from(new Set([
      ...getManualCampaignEmails(),
      normalizedEmail,
    ]));
    setEmailCampaignManualTo(nextEmails.join("\n"));
  };

  const getAdminRoleLabel = (roleType: string) => {
    if (roleType === ROLE_TYPE_MHP) {
      return "MHP";
    }
    if (roleType === "unassigned") {
      return "Unassigned";
    }
    return String(roleType || "")
      .split("_")
      .filter(Boolean)
      .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
      .join(" ");
  };

  const ensureAdminUserDirectoryLoaded = async (
    forceReload = false,
    filterOverrides?: { excludePrefixes?: string; roleType?: string },
  ) => {
    if ((!forceReload && adminUserList.length > 0) || adminUserListLoading) {
      return;
    }

    setAdminUserListLoading(true);
    try {
      const response = await backendAPIStore.adminListUsers({
        directoryView: true,
        excludePrefixes: filterOverrides?.excludePrefixes ?? adminUserExcludePrefixes,
        roleType: filterOverrides?.roleType ?? adminUserRoleFilter,
      });
      const sortedListUsersByDate = response?.Users || [];
      setAdminUserRoleCounts(response?.roleCounts || []);
      setAdminUserDirectoryTotal(Number(response?.totalCount || 0));
      setAdminUserExcludedCount(Number(response?.excludedCount || 0));

      let subscriptions = totalSubscriptions;
      if (!subscriptions?.subscriptions?.length) {
        subscriptions = await backendAPIStore.listSubscription();
        setTotalSubscriptions(subscriptions);
      }

      sortedListUsersByDate.forEach((user) => {
        const userEmail = getCognitoUserAttribute(user, "email");
        const userSubscription = subscriptions.subscriptions.find((sub: any) => sub.userId === userEmail);
        user.isSubscribed = !!userSubscription;
      });

      setAdminUserList(sortedListUsersByDate);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setAdminUserListLoading(false);
    }
  };

  const completeEmailCampaignUserSearch = async (event: { query: string }) => {
    const query = String(event.query || "").trim().toLowerCase();

    if (adminUserList.length === 0) {
      await ensureAdminUserDirectoryLoaded();
    }

    const filteredUsers = (adminUserList || [])
      .filter((user) => {
        if (!query) {
          return true;
        }

        const email = String(getCognitoUserAttribute(user, "email") || "").toLowerCase();
        const username = String(user?.Username || "").toLowerCase();
        const role = String(getCognitoUserAttribute(user, "custom:custom_role_type") || "").toLowerCase();
        const fullName = `${getCognitoUserAttribute(user, "given_name")} ${getCognitoUserAttribute(user, "family_name")}`.trim().toLowerCase();

        return email.includes(query) || username.includes(query) || role.includes(query) || fullName.includes(query);
      })
      .slice(0, 12)
      .map((user) => ({
        ...user,
        displayLabel: `${getCognitoUserAttribute(user, "email") || user?.Username}${getCognitoUserAttribute(user, "custom:custom_role_type") ? ` • ${getCognitoUserAttribute(user, "custom:custom_role_type")}` : ""}`,
      }));

    setEmailCampaignUserSuggestions(filteredUsers);
  };

  const runEmailEditorCommand = (command: string, value?: string) => {
    emailCampaignEditorRef.current?.focus();
    document.execCommand(command, false, value);
    setEmailCampaignHtmlBody(emailCampaignEditorRef.current?.innerHTML || "");
  };

  const loadEmailCampaignPreview = async () => {
    setEmailCampaignPreviewLoading(true);
    setEmailCampaignError(null);
    try {
      const response = await backendAPIStore.previewAdminCampaignEmail({
        manualToEmails: getManualCampaignEmails(),
        sendToAllActiveUsers: emailCampaignSendToAll,
        roleFilters: emailCampaignRoleFilters,
      });
      setEmailCampaignPreview(response);
    } catch (error: any) {
      setEmailCampaignError(error.message || "Unable to preview recipients.");
    } finally {
      setEmailCampaignPreviewLoading(false);
    }
  };

  const loadEmailCampaignHistory = async () => {
    setEmailCampaignHistoryLoading(true);
    try {
      const response = await backendAPIStore.getEmailCampaignHistory();
      setEmailCampaignHistory(response?.items || []);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load email campaign history.", life: 3000 });
    } finally {
      setEmailCampaignHistoryLoading(false);
    }
  };

  const loadEmailCampaignDeliveries = async (campaignId: string) => {
    if (!campaignId) return;
    setEmailCampaignDeliveriesLoading(true);
    try {
      const response = await backendAPIStore.getEmailCampaignHistory(campaignId);
      setEmailCampaignDeliveries(response?.deliveries || []);
    } catch (error: any) {
      setEmailCampaignError(error.message || "Unable to load recipient delivery status.");
    } finally {
      setEmailCampaignDeliveriesLoading(false);
    }
  };

  const emailCampaignExpectedRecipients = Number(emailCampaignResult?.totalRecipients || 0);
  const isEmailCampaignComplete = emailCampaignExpectedRecipients > 0
    && emailCampaignDeliveries.length >= emailCampaignExpectedRecipients
    && emailCampaignDeliveries.every((item) => ["sent", "failed", "skipped"].includes(String(item.status)));

  useEffect(() => {
    const campaignId = String(emailCampaignResult?.campaignId || "");
    if (!showEmailCampaignDialog || !campaignId) return undefined;
    if (isEmailCampaignComplete) return undefined;
    void loadEmailCampaignDeliveries(campaignId);
    const interval = window.setInterval(() => void loadEmailCampaignDeliveries(campaignId), 5000);
    return () => window.clearInterval(interval);
  }, [showEmailCampaignDialog, emailCampaignResult?.campaignId, emailCampaignResult?.totalRecipients, isEmailCampaignComplete]);

  const retryFailedCampaignRecipients = async (item: any) => {
    const campaignId = String(item?.campaignId || "");
    if (!campaignId || Number(item?.failedCount || 0) === 0) return;

    setRetryingCampaignId(campaignId);
    try {
      const response = await backendAPIStore.retryFailedCampaignEmails(campaignId);
      await loadEmailCampaignHistory();
      toast.current?.show({
        severity: response?.requeuedCount ? "success" : "info",
        summary: response?.requeuedCount ? "Failed emails queued again" : "No failed emails to retry",
        detail: response?.requeuedCount
          ? `${response.requeuedCount} failed recipient${response.requeuedCount === 1 ? "" : "s"} queued again.`
          : "This campaign no longer has failed recipients.",
        life: 4000,
      });
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: getErrorTitle(error),
        detail: error.message || "Unable to retry failed recipients.",
        life: 3500,
      });
    } finally {
      setRetryingCampaignId(null);
    }
  };

  const requeueUnattemptedCampaignDeliveries = async () => {
    const campaignId = String(emailCampaignResult?.campaignId || "");
    if (!campaignId) return;

    setRequeueingUnattemptedCampaign(true);
    try {
      const response = await backendAPIStore.retryUnattemptedCampaignEmails(campaignId);
      await loadEmailCampaignDeliveries(campaignId);
      toast.current?.show({
        severity: response?.requeuedCount ? "success" : "info",
        summary: response?.requeuedCount ? "Emails queued again" : "No emails to queue",
        detail: response?.requeuedCount
          ? `${response.requeuedCount} recipient${response.requeuedCount === 1 ? "" : "s"} with zero attempts queued again.`
          : "Every recipient has already been attempted or completed.",
        life: 4000,
      });
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: getErrorTitle(error),
        detail: error.message || "Unable to queue the unattempted recipients again.",
        life: 3500,
      });
    } finally {
      setRequeueingUnattemptedCampaign(false);
    }
  };

  const onSendEmailCampaign = async () => {
    const manualToEmails = getManualCampaignEmails();
    if (!emailCampaignSubject.trim()) {
      setEmailCampaignError("Subject is required.");
      return;
    }
    if (!emailCampaignHtmlBody.trim()) {
      setEmailCampaignError("Email body is required.");
      return;
    }
    if (!emailCampaignSendToAll && manualToEmails.length === 0) {
      setEmailCampaignError("Add at least one email address or choose all active users.");
      return;
    }

    setSendingEmailCampaign(true);
    setEmailCampaignError(null);
    try {
      const preview = emailCampaignPreview || await backendAPIStore.previewAdminCampaignEmail({
        manualToEmails,
        sendToAllActiveUsers: emailCampaignSendToAll,
        roleFilters: emailCampaignRoleFilters,
      });
      setEmailCampaignPreview(preview);

      await new Promise<void>((resolve, reject) => {
        confirmDialog({
          message: (
            <div style={{ ...appAccentPanelStyle, maxWidth: "32rem" }}>
              <div style={{ fontWeight: 700, color: "#9a3412" }}>Send email campaign?</div>
              <div className="mt-2" style={{ ...appMutedTextStyle, lineHeight: 1.7 }}>
                {preview.totalRecipients || 0} total recipients will receive an individually personalized message. Delivery is queued and paced to stay within SES limits.
              </div>
            </div>
          ),
          header: "Confirm Email Send",
          icon: "pi pi-envelope",
          acceptClassName: "p-button-warning p-button-outlined p-button-rounded",
          rejectClassName: "p-button-secondary p-button-outlined p-button-rounded",
          acceptLabel: "Send",
          rejectLabel: "Cancel",
          accept: () => resolve(),
          reject: () => reject(new Error("Send cancelled")),
        });
      });

      const response = await backendAPIStore.sendAdminCampaignEmail({
        templateType: emailCampaignTemplateType,
        subject: emailCampaignSubject,
        introText: emailCampaignIntro,
        htmlBody: emailCampaignHtmlBody,
        manualToEmails,
        sendToAllActiveUsers: emailCampaignSendToAll,
        roleFilters: emailCampaignRoleFilters,
      });
      setEmailCampaignResult(response);
      setEmailCampaignDeliveries([]);
      await loadEmailCampaignHistory();
      toast.current?.show({
        severity: "success",
        summary: "Email campaign queued",
        detail: `${response?.totalRecipients || 0} individual emails are being delivered. Recipient status updates below.`,
        life: 4000,
      });
    } catch (error: any) {
      if (error.message !== "Send cancelled") {
        setEmailCampaignError(error.message || "Unable to send email campaign.");
      }
    } finally {
      setSendingEmailCampaign(false);
    }
  };

  const getFolderOptionsForBinderType = (binderType: BinderType) => {
    const folders = binderType === BinderType.RESIDENT ? RESIDENT_BINDER_SYSTEM_FOLDERS : HOME_BINDER_SYSTEM_FOLDERS;
    return folders.map((folder) => ({
      label: folder.name,
      value: folder.code,
    }));
  };

  const loadBinderRules = async (binderType: BinderType) => {
    setBinderRulesLoading(true);
    try {
      const rules = await backendAPIStore.listBinderRules(binderType);
      setBinderRules(rules || []);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load binder rules.", life: 3000 });
    } finally {
      setBinderRulesLoading(false);
    }
  };

  const loadBinderRuleSources = async (binderType: BinderType) => {
    setBinderRuleSourcesLoading(true);
    try {
      const sources = await backendAPIStore.listBinderRuleSources(binderType);
      setBinderRuleSources(sources || []);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load binder rule sources.", life: 3000 });
    } finally {
      setBinderRuleSourcesLoading(false);
    }
  };

  const loadBinderRuleAlerts = async (binderType: BinderType) => {
    setBinderRuleAlertsLoading(true);
    try {
      const alerts = await backendAPIStore.listBinderRuleChangeAlerts(binderType);
      setBinderRuleAlerts(alerts || []);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load binder rule alerts.", life: 3000 });
    } finally {
      setBinderRuleAlertsLoading(false);
    }
  };

  const openCreateBinderRuleDialog = () => {
    setBinderRuleDialogMode("create");
    setBinderRuleForm({
      binderType: selectedBinderRuleType,
      folderCode: getFolderOptionsForBinderType(selectedBinderRuleType)[0]?.value || "",
      title: "",
      description: "",
      citation: "",
      sourceUrl: "",
      expectedDocumentCount: 1,
      requiredForCompliance: true,
      effectiveFrom: new Date().toISOString().slice(0, 10),
      status: "active",
    });
    setShowBinderRuleDialog(true);
  };

  const openEditBinderRuleDialog = (rule: BinderRule) => {
    setBinderRuleDialogMode("edit");
    setBinderRuleForm({ ...rule });
    setShowBinderRuleDialog(true);
  };

  const openVersionBinderRuleDialog = (rule: BinderRule) => {
    setBinderRuleDialogMode("version");
    setBinderRuleForm({
      ...rule,
      ruleId: undefined,
      supersedesRuleId: rule.ruleId,
      versionNumber: undefined,
      effectiveFrom: new Date().toISOString().slice(0, 10),
      effectiveTo: undefined,
      status: "active",
    });
    setShowBinderRuleDialog(true);
  };

  const onSaveBinderRule = async () => {
    if (!binderRuleForm.binderType || !binderRuleForm.folderCode || !binderRuleForm.title) {
      toast.current?.show({ severity: "warn", summary: "Missing fields", detail: "Binder type, folder, and title are required.", life: 3000 });
      return;
    }

    setSavingBinderRule(true);
    try {
      if (binderRuleDialogMode === "edit" && binderRuleForm.ruleId) {
        await backendAPIStore.updateBinderRule(binderRuleForm as BinderRule);
      } else {
        await backendAPIStore.createBinderRule(binderRuleForm as BinderRule);
      }
      setShowBinderRuleDialog(false);
      await loadBinderRules((binderRuleForm.binderType as BinderType) || selectedBinderRuleType);
      toast.current?.show({ severity: "success", summary: "Rule saved", detail: "Binder rule registry updated successfully.", life: 3000 });
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to save binder rule.", life: 3000 });
    } finally {
      setSavingBinderRule(false);
    }
  };

  const onRetireBinderRule = (rule: BinderRule) => {
    confirmDialog({
      message: `Retire version ${rule.versionNumber || 1} for ${rule.title || "this rule"}?`,
      header: "Retire Binder Rule",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-warning p-button-outlined p-button-rounded",
      rejectClassName: "p-button-secondary p-button-outlined p-button-rounded",
      accept: async () => {
        try {
          await backendAPIStore.retireBinderRule(rule.ruleId!);
          await loadBinderRules(selectedBinderRuleType);
          toast.current?.show({ severity: "success", summary: "Rule retired", detail: "Binder rule version retired.", life: 3000 });
        } catch (error: any) {
          toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to retire binder rule.", life: 3000 });
        }
      },
    });
  };

  const openCreateBinderRuleSourceDialog = () => {
    setBinderRuleSourceForm({
      binderType: selectedBinderRuleType,
      title: "",
      citation: "",
      sourceType: "WAC",
      sourceUrl: "",
      status: "active",
    });
    setShowBinderRuleSourceDialog(true);
  };

  const openEditBinderRuleSourceDialog = (source: BinderRuleSource) => {
    setBinderRuleSourceForm({ ...source });
    setShowBinderRuleSourceDialog(true);
  };

  const onSaveBinderRuleSource = async () => {
    if (!binderRuleSourceForm.binderType || !binderRuleSourceForm.title || !binderRuleSourceForm.sourceUrl) {
      toast.current?.show({ severity: "warn", summary: "Missing fields", detail: "Binder type, title, and source URL are required.", life: 3000 });
      return;
    }

    setSavingBinderRuleSource(true);
    try {
      if (binderRuleSourceForm.sourceId) {
        await backendAPIStore.updateBinderRuleSource(binderRuleSourceForm as BinderRuleSource);
      } else {
        await backendAPIStore.createBinderRuleSource(binderRuleSourceForm as BinderRuleSource);
      }
      setShowBinderRuleSourceDialog(false);
      await loadBinderRuleSources((binderRuleSourceForm.binderType as BinderType) || selectedBinderRuleType);
      toast.current?.show({ severity: "success", summary: "Source saved", detail: "Binder rule source updated successfully.", life: 3000 });
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to save binder rule source.", life: 3000 });
    } finally {
      setSavingBinderRuleSource(false);
    }
  };

  const onDeleteBinderRuleSource = (source: BinderRuleSource) => {
    confirmDialog({
      message: `Delete ${source.title || "this source"} from binder monitoring?`,
      header: "Delete Binder Rule Source",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-warning p-button-outlined p-button-rounded",
      rejectClassName: "p-button-secondary p-button-outlined p-button-rounded",
      accept: async () => {
        try {
          await backendAPIStore.deleteBinderRuleSource(source.sourceId!);
          await loadBinderRuleSources(selectedBinderRuleType);
          toast.current?.show({ severity: "success", summary: "Source deleted", detail: "Binder rule source removed.", life: 3000 });
        } catch (error: any) {
          toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to delete binder rule source.", life: 3000 });
        }
      },
    });
  };

  const onRunBinderRuleMonitor = async (sourceId?: string) => {
    setRunningBinderRuleMonitor(true);
    try {
      const response = await backendAPIStore.runBinderRuleMonitor({ binderType: selectedBinderRuleType, sourceId });
      await Promise.all([
        loadBinderRuleSources(selectedBinderRuleType),
        loadBinderRuleAlerts(selectedBinderRuleType),
      ]);
      toast.current?.show({
        severity: "success",
        summary: "Monitor complete",
        detail: `${response?.checkedSourceCount || 0} sources checked. ${response?.changeCount || 0} potential changes detected.`,
        life: 4000,
      });
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to run binder rule monitor.", life: 3000 });
    } finally {
      setRunningBinderRuleMonitor(false);
    }
  };

  const openBinderRuleSnapshotDialog = async (source: BinderRuleSource) => {
    setSelectedBinderRuleSource(source);
    setSelectedBinderRuleSnapshot(null);
    setShowBinderRuleSnapshotDialog(true);
    setBinderRuleSnapshotsLoading(true);
    try {
      const snapshots = await backendAPIStore.listBinderRuleSnapshots(source.sourceId!);
      setBinderRuleSnapshots(snapshots || []);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load binder rule snapshots.", life: 3000 });
    } finally {
      setBinderRuleSnapshotsLoading(false);
    }
  };

  const onViewBinderRuleSnapshot = async (snapshotId: string) => {
    setSelectedBinderRuleSnapshotLoading(true);
    try {
      const snapshot = await backendAPIStore.getBinderRuleSnapshot(snapshotId);
      setSelectedBinderRuleSnapshot(snapshot || null);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load binder rule snapshot.", life: 3000 });
    } finally {
      setSelectedBinderRuleSnapshotLoading(false);
    }
  };

  const onResolveBinderRuleAlert = async (alert: BinderRuleChangeAlert) => {
    try {
      await backendAPIStore.updateBinderRuleChangeAlert({
        ...alert,
        reviewStatus: "resolved",
      } as BinderRuleChangeAlert);
      await loadBinderRuleAlerts(selectedBinderRuleType);
      toast.current?.show({ severity: "success", summary: "Alert resolved", detail: "Binder rule change alert marked as resolved.", life: 3000 });
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to resolve binder rule alert.", life: 3000 });
    }
  };

  const getAdminUserProfileDetails = async (user: any) => {
    try {
      const userId = user.Attributes.find((attr: any) => attr.Name === "sub")?.Value;
      const userProfile = await backendAPIStore.getUserProfile(userId);
      confirmDialog({
        message: (
          <div style={{ ...appNeutralPanelStyle, padding: "1rem" }}>
            <div className="grid">
              <div className="col-12 md:col-6"><strong>Username:</strong> {user.Username}</div>
              <div className="col-12 md:col-6"><strong>Email:</strong> {user.Attributes.find((attr: any) => attr.Name === "email")?.Value}</div>
              <div className="col-12 md:col-6"><strong>Phone Number:</strong> {userProfile?.phoneNumber || "N/A"}</div>
              <div className="col-12 md:col-6"><strong>Full Name:</strong> {`${userProfile?.firstName || ""} ${userProfile?.lastName || ""}`}</div>
              <div className="col-12"><strong>Role:</strong> {user.Attributes.find((attr: any) => attr.Name === "custom:custom_role_type")?.Value}</div>
            </div>
          </div>
        ),
        header: "User Details",
        icon: "pi pi-user",
        acceptLabel: "Done",
      });
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    }
  };

  const getAdminActiveUserDetails = async (userId: string) => {
    setSelectedAdminUserEmail(userId);
    setAdminUserHomeDetails([]);
    setShowAdminUserHomesDialog(true);
    setAdminUserHomeDetailsLoading(true);
    try {
      const matchingUser = adminUserList.find((user) =>
        String(getCognitoUserAttribute(user, "email")).trim().toLowerCase() === String(userId || "").trim().toLowerCase(),
      );
      const username = String(matchingUser?.Username || "").trim();
      if (!username) {
        return;
      }
      const userHomes = await backendAPIStore.getHomeListForUser(username);
      const homeWithDetails = await Promise.all(userHomes.map(async (home: any) => {
        const residents = await backendAPIStore.getResidentsForHome(home.homeId);
        const activeResidents = residents ? residents.filter((resident: any) => resident.active) : [];
        return { ...home, residents: activeResidents.length };
      }));
      setAdminUserHomeDetails(homeWithDetails);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load homes for this user.", life: 3000 });
    } finally {
      setAdminUserHomeDetailsLoading(false);
    }
  };

  const onAdminListUsers = async () => {
    setActiveAdminAction("users");
    try {
      await ensureAdminUserDirectoryLoaded();
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setShowAdminList(true);
      setShowCustomerFeedbacks(false);
    }
  };

  const onAdminGetCustomerFeedbacks = async () => {
    setActiveAdminAction("feedback");
    setCustomerFeedbacksLoading(true);
    try {
      const response = await backendAPIStore.listCustomerFeedback();
      setCustomerFeedbacks(response);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setCustomerFeedbacksLoading(false);
      setShowCustomerFeedbacks(true);
      setShowAdminList(false);
    }
  };

  const formatCustomerFeedbackDate = (value: any) => value
    ? new Intl.DateTimeFormat("en-US", { timeZone: "America/Los_Angeles", dateStyle: "medium", timeStyle: "short" }).format(new Date(value))
    : "N/A";

  const customerFeedbackTypeLabel = (feedback: any) => feedback?.feedbackType?.name
    || feedback?.feedbackType?.code
    || (typeof feedback?.feedbackType === "string" ? feedback.feedbackType : "General");

  const openAdminCustomerFeedback = async (feedback: any) => {
    setSelectedCustomerFeedback(feedback);
    setCustomerFeedbackReply("");
    setCustomerFeedbackMessages([]);
    setCustomerFeedbackMessagesLoading(true);
    try {
      const response = await backendAPIStore.listCustomerFeedbackMessages(String(feedback?.feedbackId || ""));
      setCustomerFeedbackMessages(Array.isArray(response?.messages) ? response.messages : []);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error?.message || "Unable to load feedback history.", life: 3000 });
    } finally {
      setCustomerFeedbackMessagesLoading(false);
    }
  };

  const submitAdminCustomerFeedbackReply = async () => {
    const message = customerFeedbackReply.trim();
    if (!selectedCustomerFeedback?.feedbackId || !message || customerFeedbackReplyLoading) {
      return;
    }
    setCustomerFeedbackReplyLoading(true);
    try {
      const replyResponse = await backendAPIStore.replyToCustomerFeedback(selectedCustomerFeedback.feedbackId, message);
      const [threadResponse, feedbackResponse] = await Promise.all([
        backendAPIStore.listCustomerFeedbackMessages(selectedCustomerFeedback.feedbackId),
        backendAPIStore.listCustomerFeedback(),
      ]);
      setCustomerFeedbackMessages(Array.isArray(threadResponse?.messages) ? threadResponse.messages : []);
      setCustomerFeedbacks(Array.isArray(feedbackResponse) ? feedbackResponse : []);
      setSelectedCustomerFeedback((current: any) => (Array.isArray(feedbackResponse)
        ? feedbackResponse.find((item: any) => item?.feedbackId === current?.feedbackId) || current
        : current));
      setCustomerFeedbackReply("");
      toast.current?.show({ severity: "success", summary: "Reply sent", detail: replyResponse?.emailNotification?.status === "sent" ? "The user was notified by email." : "Reply saved, but email delivery needs attention.", life: 3000 });
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error?.message || "Unable to send reply.", life: 3000 });
    } finally {
      setCustomerFeedbackReplyLoading(false);
    }
  };

  const onLoadObservabilitySummary = async () => {
    setActiveAdminAction("metrics");
    setObservabilityLoading(true);
    try {
      const response = await backendAPIStore.getAdminObservabilitySummary(observabilityRange);
      setObservabilitySummary(response);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setObservabilityLoading(false);
    }
  };

  const onLoadActivityLogs = async () => {
    setActiveAdminAction("activity");
    setActivityLogsLoading(true);
    try {
      const response = await backendAPIStore.getAdminActivityLogs(activityLogRange, activityLogSearch);
      setActivityLogs(response);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setActivityLogsLoading(false);
    }
  };

  const AUDIT_EVENT_PAGE_SIZE = 50;

  const onLoadAuditEvents = async () => {
    setAuditEventsLoading(true);
    try {
      const response = await backendAPIStore.getAdminAuditEvents(
        auditEventRange,
        auditEventSearch,
        auditEventType,
        auditEventStatus,
        AUDIT_EVENT_PAGE_SIZE,
      );
      setAuditEvents(response);
      setAuditEventPages([response]);
      setAuditEventPageIndex(0);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setAuditEventsLoading(false);
    }
  };

  const onPreviousAuditEventsPage = () => {
    setAuditEventPageIndex((current) => Math.max(current - 1, 0));
  };

  const onNextAuditEventsPage = async () => {
    const currentPage = auditEventPages[auditEventPageIndex];
    if (!currentPage?.nextToken) {
      return;
    }

    if (auditEventPages[auditEventPageIndex + 1]) {
      setAuditEventPageIndex((current) => current + 1);
      return;
    }

    setAuditEventsLoading(true);
    try {
      const response = await backendAPIStore.getAdminAuditEvents(
        auditEventRange,
        auditEventSearch,
        auditEventType,
        auditEventStatus,
        AUDIT_EVENT_PAGE_SIZE,
        currentPage.nextToken,
      );
      setAuditEventPages((current) => [...current, response]);
      setAuditEventPageIndex((current) => current + 1);
      setAuditEvents(response);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setAuditEventsLoading(false);
    }
  };

  const renderMetricCard = (label: string, value: React.ReactNode, tone: "neutral" | "accent" = "neutral") => (
    <div style={{ ...(tone === "accent" ? appAccentPanelStyle : appNeutralPanelStyle), padding: "0.7rem 0.85rem", borderRadius: "10px" }}>
      <div style={{ fontSize: "0.7rem", lineHeight: 1.2, letterSpacing: "0.04em", textTransform: "uppercase", color: "#64748b" }}>{label}</div>
      <div className="mt-1" style={{ fontSize: "1.25rem", lineHeight: 1.2, fontWeight: 700, color: "#0f172a", overflowWrap: "anywhere" }}>{value}</div>
    </div>
  );

  const renderBinderRuleStatus = (rowData: BinderRule) => {
    const normalizedStatus = String(rowData.status || "active").toLowerCase();
    const severity = normalizedStatus === "active" ? "success" : normalizedStatus === "retired" ? "warning" : "info";
    const label = normalizedStatus.charAt(0).toUpperCase() + normalizedStatus.slice(1);
    return <Tag value={label} severity={severity as any} />;
  };

  const onShowInviteActivity = () => {
    setActiveAdminAction("invites");
  };

  const onShowBinderTools = () => {
    setActiveAdminAction("binder");
  };

  const loadProviderDirectoryDashboard = async () => {
    setProviderDirectoryLoading(true);
    try {
      const dashboardResponse = await backendAPIStore.getProviderDirectoryDashboard(10, 25, 50);
      setProviderDirectoryDashboard(dashboardResponse || null);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load provider directory data.", life: 3000 });
    } finally {
      setProviderDirectoryLoading(false);
    }
  };

  const onShowProviderDirectory = async () => {
    setActiveAdminAction("providerDirectory");
    await loadProviderDirectoryDashboard();
  };

  const onShowNurseDirectory = async () => {
    setActiveAdminAction("nurseDirectory");
    await loadProviderDirectoryDashboard();
  };

  const getProviderCurrentEntriesFilterParams = () => ({
    search: String(providerCurrentEntriesGlobalFilter || "").trim(),
    facilityPOC: String(providerCurrentEntriesFilters?.facilityPOC?.value || "").trim(),
    telephoneNumber: String(providerCurrentEntriesFilters?.telephoneNumber?.value || "").trim(),
    speciality: String(providerCurrentEntriesFilters?.speciality?.value || "").trim(),
    formattedAddress: String(providerCurrentEntriesFilters?.formattedAddress?.value || "").trim(),
    licensedBedCount: String(providerCurrentEntriesFilters?.licensedBedCount?.value || "").trim(),
    hasReports: String(providerCurrentEntriesFilters?.hasReports?.value || "").trim(),
  });

  const loadProviderCurrentEntriesPage = async (pageIndex: number, nextToken: string, pageSize: number) => {
    setProviderDirectoryLoading(true);
    try {
      const response = await backendAPIStore.listProviderDirectoryCurrentEntriesPage({
        limit: pageSize,
        nextToken,
        ...getProviderCurrentEntriesFilterParams(),
      });
      const items = response?.items || [];
      setProviderCurrentEntries(items);
      setProviderCurrentEntriesPageIndex(pageIndex);
      setProviderCurrentEntriesPageCache((current) => ({
        ...current,
        [pageIndex]: items,
      }));
      setProviderCurrentEntriesNextTokens((current) => {
        const updated = { ...current, [pageIndex]: nextToken };
        if (response?.nextToken) {
          updated[pageIndex + 1] = response.nextToken;
        } else {
          delete updated[pageIndex + 1];
        }
        return updated;
      });
      setProviderCurrentEntriesHasMoreByPage((current) => ({
        ...current,
        [pageIndex]: Boolean(response?.hasMore),
      }));
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to load provider directory entries.", life: 3000 });
    } finally {
      setProviderDirectoryLoading(false);
    }
  };

  const resetProviderCurrentEntriesPagination = async (pageSize: number = providerCurrentEntriesPageSize) => {
    setProviderCurrentEntriesPageIndex(0);
    setProviderCurrentEntriesPageCache({});
    setProviderCurrentEntriesNextTokens({ 0: "" });
    setProviderCurrentEntriesHasMoreByPage({});
    await loadProviderCurrentEntriesPage(0, "", pageSize);
  };

  const onApplyAdminUserDirectoryFilters = async () => {
    await ensureAdminUserDirectoryLoaded(true);
  };

  const onExportProviderDirectoryCurrentEntries = async () => {
    setProviderDirectoryExporting(true);
    try {
      const exportResult = await backendAPIStore.exportProviderDirectoryCurrentEntries();
      if (!exportResult?.downloadUrl) {
        throw new Error("The provider directory export did not return a download link.");
      }

      const downloadLink = document.createElement("a");
      downloadLink.href = exportResult.downloadUrl;
      downloadLink.download = exportResult.fileName || "provider-directory-current-entries.xlsx";
      downloadLink.rel = "noopener";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();

      toast.current?.show({
        severity: "success",
        summary: "Excel export ready",
        detail: `${exportResult.rowCount || 0} Current Entries were included in the download.`,
        life: 4000,
      });
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: getErrorTitle(error),
        detail: error.message || "Unable to export the provider directory.",
        life: 4000,
      });
    } finally {
      setProviderDirectoryExporting(false);
    }
  };

  const onStartProviderDirectoryImport = async () => {
    setProviderDirectoryRunning(true);
    try {
      const response = await backendAPIStore.startProviderDirectoryImport();
      toast.current?.show({
        severity: "success",
        summary: "Import queued",
        detail: response?.summary || "Provider directory import has been queued.",
        life: 3000,
      });
      await loadProviderDirectoryDashboard();
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to start provider directory import.", life: 3000 });
    } finally {
      setProviderDirectoryRunning(false);
    }
  };

  const onStartNurseDirectoryImport = async () => {
    setNurseDirectoryRunning(true);
    try {
      const response = await backendAPIStore.startNurseDirectoryImport();
      toast.current?.show({
        severity: "success",
        summary: response?.status === "completed" ? "Nurse import completed" : "Nurse import queued",
        detail: response?.summary || "Nurse directory import has been queued.",
        life: 3000,
      });
      await loadProviderDirectoryDashboard();
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to start nurse directory import.", life: 3000 });
    } finally {
      setNurseDirectoryRunning(false);
    }
  };

  const onStartProviderDirectoryReportSync = async () => {
    setProviderDirectoryReportRunning(true);
    try {
      const response = await backendAPIStore.startProviderDirectoryReportSync();
      toast.current?.show({
        severity: "success",
        summary: "Report sync queued",
        detail: response?.summary || "Provider directory report sync has been queued.",
        life: 3000,
      });
      await loadProviderDirectoryDashboard();
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message || "Unable to start provider directory report sync.", life: 3000 });
    } finally {
      setProviderDirectoryReportRunning(false);
    }
  };

  const renderBinderRuleActions = (rowData: BinderRule) => (
    <div className="flex flex-wrap gap-2">
      <Button label="Edit" {...adminButtonProps} size="small" onClick={() => openEditBinderRuleDialog(rowData)} />
      {String(rowData.status || "active").toLowerCase() === "active" ? (
        <>
          <Button label="New Version" {...adminButtonProps} size="small" onClick={() => openVersionBinderRuleDialog(rowData)} />
          <Button label="Retire" severity="secondary" outlined rounded size="small" onClick={() => onRetireBinderRule(rowData)} />
        </>
      ) : null}
    </div>
  );

  const renderBinderRuleSourceStatus = (rowData: BinderRuleSource) => (
    <Tag value={String(rowData.status || "active").replace(/\b\w/g, (char) => char.toUpperCase())} severity={String(rowData.status || "active").toLowerCase() === "active" ? "success" : "warning"} />
  );

  const renderBinderRuleSourceActions = (rowData: BinderRuleSource) => (
    <div className="flex flex-wrap gap-2">
      <Button label="Edit" {...adminButtonProps} size="small" onClick={() => openEditBinderRuleSourceDialog(rowData)} />
      <Button label="Check Now" {...adminButtonProps} size="small" loading={runningBinderRuleMonitor} onClick={() => void onRunBinderRuleMonitor(rowData.sourceId)} />
      <Button label="Snapshots" {...adminButtonProps} size="small" onClick={() => void openBinderRuleSnapshotDialog(rowData)} />
      <Button label="Delete" severity="secondary" outlined rounded size="small" onClick={() => onDeleteBinderRuleSource(rowData)} />
    </div>
  );

  const renderBinderRuleAlertStatus = (rowData: BinderRuleChangeAlert) => (
    <Tag
      value={String(rowData.reviewStatus || "open").replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}
      severity={String(rowData.reviewStatus || "open").toLowerCase() === "resolved" ? "success" : "warning"}
    />
  );

  const renderBinderRuleAlertActions = (rowData: BinderRuleChangeAlert) => (
    String(rowData.reviewStatus || "open").toLowerCase() === "resolved"
      ? <span style={appMutedTextStyle}>Resolved</span>
      : <Button label="Resolve" {...adminButtonProps} size="small" onClick={() => void onResolveBinderRuleAlert(rowData)} />
  );

  const renderProviderDirectoryRunStatus = (rowData: ProviderDirectoryRun) => {
    const normalizedStatus = String(rowData.status || "queued").toLowerCase();
    const severity =
      normalizedStatus === "completed" ? "success"
        : normalizedStatus === "failed" ? "danger"
          : normalizedStatus === "running" ? "warning"
            : "info";
    return <Tag value={normalizedStatus.replace(/\b\w/g, (char) => char.toUpperCase())} severity={severity as any} />;
  };

  const renderProviderDirectoryChangeType = (rowData: ProviderDirectoryChange) => {
    const normalizedType = String(rowData.changeType || "updated").toLowerCase();
    const severity =
      normalizedType === "new" ? "success"
        : normalizedType === "removed" ? "danger"
          : normalizedType === "reactivated" ? "info"
            : "warning";
    return <Tag value={normalizedType.replace(/\b\w/g, (char) => char.toUpperCase())} severity={severity as any} />;
  };

  const openProviderDirectoryChangeDialog = (change: ProviderDirectoryChange) => {
    setSelectedProviderDirectoryChange(change);
    setShowProviderDirectoryChangeDialog(true);
  };

  const renderProviderDirectoryChangedFields = (rowData: ProviderDirectoryChange) => {
    const changedFieldsCount = rowData.fieldDiffs?.length || 0;
    if (!changedFieldsCount) {
      return "No tracked field changes";
    }

    return (
      <div className="flex flex-wrap align-items-center gap-2">
        <span>{changedFieldsCount} fields changed</span>
        <Button
          label="View Details"
          size="small"
          severity="warning"
          outlined
          rounded
          onClick={() => openProviderDirectoryChangeDialog(rowData)}
        />
      </div>
    );
  };

  const renderProviderDirectoryGeocodeStatus = (rowData: ProviderDirectoryEntry) => {
    const normalizedStatus = String(rowData.geocodeStatus || (rowData.latitude && rowData.longitude ? "resolved" : "pending")).toLowerCase();
    const severity =
      normalizedStatus === "resolved" ? "success"
        : normalizedStatus === "failed" ? "danger"
          : normalizedStatus === "unresolved" ? "warning"
            : "info";
    return <Tag value={normalizedStatus.replace(/\b\w/g, (char) => char.toUpperCase())} severity={severity as any} />;
  };

  const renderProviderDirectoryCoordinates = (rowData: ProviderDirectoryEntry) => {
    if (rowData.latitude === null || rowData.latitude === undefined || rowData.longitude === null || rowData.longitude === undefined) {
      return "N/A";
    }

    return `${Number(rowData.latitude).toFixed(4)}, ${Number(rowData.longitude).toFixed(4)}`;
  };

  const renderProviderDirectoryReports = (rowData: ProviderDirectoryEntry) => {
    const hasReports = String(rowData.hasReports || "").trim().toLowerCase();
    const reportLink = String(rowData.reportsLocation || "").trim();

    if (!hasReports || hasReports === "no") {
      return "No";
    }

    if (reportLink) {
      return (
        <a href={reportLink} target="_blank" rel="noreferrer" style={{ color: "#185DA2", fontWeight: 600 }}>
          Yes, open report
        </a>
      );
    }

    return "Yes";
  };

  const renderProviderDirectoryReportStatus = (rowData: ProviderDirectoryEntry) => {
    const normalizedStatus = String(rowData.reportPageStatus || "not_fetched").toLowerCase();
    const severity =
      normalizedStatus === "completed" ? "success"
        : normalizedStatus === "failed" ? "danger"
          : normalizedStatus === "missing_report_url" ? "warning"
            : "info";
    return <Tag value={normalizedStatus.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())} severity={severity as any} />;
  };

  const renderProviderDirectoryReportCategories = (rowData: ProviderDirectoryEntry) => {
    const categoryCounts = rowData.reportCategoryCounts || {};
    const categoryEntries = Object.entries(categoryCounts).filter(([, count]) => Number(count || 0) > 0);
    if (!categoryEntries.length) {
      return "N/A";
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "0.2rem" }}>
        {categoryEntries.map(([category, count]) => (
          <span key={category}>{category}: {count}</span>
        ))}
      </div>
    );
  };

  const renderProviderDirectoryActiveStatus = (rowData: ProviderDirectoryEntry) => (
    <Tag
      value={rowData.active === false ? "Inactive" : "Active"}
      severity={rowData.active === false ? "danger" : "success"}
    />
  );

  const renderProviderDirectoryCurrentEntryRow = (rowData: ProviderDirectoryEntry) => ({
    backgroundColor: rowData.active === false ? "#fef2f2" : undefined,
  });

  const onProviderCurrentEntriesGlobalFilterChange = (value: string) => {
    setProviderCurrentEntriesGlobalFilter(value);
    setProviderCurrentEntriesFilters((current: any) => ({
      ...current,
      global: {
        ...current.global,
        value,
      },
    }));
  };

  const onProviderCurrentEntriesFilter = (filters: any) => {
    setProviderCurrentEntriesFilters(filters);
  };

  const onNurseCurrentEntriesFilter = (filters: any) => {
    setNurseCurrentEntriesFilters(filters);
  };

  const onNurseCurrentEntriesGlobalFilterChange = (value: string) => {
    setNurseCurrentEntriesGlobalFilter(value);
    setNurseCurrentEntriesFilters((current: any) => ({
      ...current,
      global: { ...(current?.global || { matchMode: FilterMatchMode.CONTAINS }), value },
    }));
  };

  const onProviderCurrentEntriesPage = async (event: any) => {
    const requestedPageSize = Number(event.rows || providerCurrentEntriesPageSize);
    const requestedPageIndex = Math.floor(Number(event.first || 0) / Math.max(requestedPageSize, 1));

    if (requestedPageSize !== providerCurrentEntriesPageSize) {
      setProviderCurrentEntriesPageSize(requestedPageSize);
      return;
    }

    if (requestedPageIndex === providerCurrentEntriesPageIndex) {
      return;
    }

    const cachedPage = providerCurrentEntriesPageCache[requestedPageIndex];
    if (cachedPage) {
      setProviderCurrentEntries(cachedPage);
      setProviderCurrentEntriesPageIndex(requestedPageIndex);
      return;
    }

    const nextToken = providerCurrentEntriesNextTokens[requestedPageIndex];
    if (!nextToken) {
      return;
    }

    await loadProviderCurrentEntriesPage(requestedPageIndex, nextToken, providerCurrentEntriesPageSize);
  };

  const latestProviderRun = providerDirectoryDashboard?.latestRun || null;
  const providerRuns = providerDirectoryDashboard?.runs || [];
  const providerChanges = providerDirectoryDashboard?.changes || [];
  const providerLatestRunChanges = providerDirectoryDashboard?.latestRunChanges || [];
  const latestNurseRun = providerDirectoryDashboard?.latestNurseRun || null;
  const nurseRuns = providerDirectoryDashboard?.nurseRuns || [];
  const nurseChanges = providerDirectoryDashboard?.nurseChanges || [];
  const nurseCurrentEntries = providerDirectoryDashboard?.nurseCurrentEntries || [];
  const latestProviderReportRun = providerDirectoryDashboard?.latestReportRun || null;
  const providerCurrentActiveCount = latestProviderRun?.rowCount || providerCurrentEntries.filter((entry) => entry.active !== false).length;
  const latestProviderNewHomes = React.useMemo(
    () => providerLatestRunChanges.filter((change) => String(change?.changeType || "").toLowerCase() === "new"),
    [providerLatestRunChanges],
  );
  const latestProviderNewHomesByCity = React.useMemo(
    () => {
      const grouped = new Map<string, { city: string; count: number; homes: string[]; specialities: string[] }>();
      latestProviderNewHomes.forEach((change) => {
        const city = String(change?.currentSnapshot?.locationCity || change?.previousSnapshot?.locationCity || "Unknown City").trim();
        const facility = String(change?.facilityName || "Unknown Home").trim();
        const speciality = String(change?.currentSnapshot?.speciality || change?.previousSnapshot?.speciality || "No speciality listed").trim();
        const existing = grouped.get(city) || { city, count: 0, homes: [], specialities: [] };
        existing.count += 1;
        existing.homes.push(facility);
        if (speciality && !existing.specialities.includes(speciality)) {
          existing.specialities.push(speciality);
        }
        grouped.set(city, existing);
      });
      return Array.from(grouped.values()).sort((left, right) => right.count - left.count || left.city.localeCompare(right.city));
    },
    [latestProviderNewHomes],
  );
  const latestProviderNewHomeCitySummary = React.useMemo(() => {
    return latestProviderNewHomesByCity.map((item) => `${item.city}${item.count > 1 ? ` (${item.count})` : ""}`);
  }, [latestProviderNewHomesByCity]);
  const latestProviderNewHomeSpecialitySummary = React.useMemo(() => {
    const counts = new Map<string, number>();
    latestProviderNewHomes.forEach((change) => {
      const speciality = String(change?.currentSnapshot?.speciality || change?.previousSnapshot?.speciality || "").trim();
      if (!speciality) return;
      counts.set(speciality, (counts.get(speciality) || 0) + 1);
    });
    return Array.from(counts.entries())
      .sort((left, right) => right[1] - left[1] || left[0].localeCompare(right[0]))
      .map(([speciality, count]) => `${speciality}${count > 1 ? ` (${count})` : ""}`);
  }, [latestProviderNewHomes]);
  const latestProviderNewHomeLines = React.useMemo(
    () => latestProviderNewHomes.map((change) => {
      const facility = String(change?.facilityName || "Unknown Home").trim();
      const city = String(change?.currentSnapshot?.locationCity || change?.previousSnapshot?.locationCity || "Unknown City").trim();
      const speciality = String(change?.currentSnapshot?.speciality || change?.previousSnapshot?.speciality || "No speciality listed").trim();
      return `- ${facility} — ${city} — ${speciality}`;
    }),
    [latestProviderNewHomes],
  );
  const providerTodayStatusSummary = React.useMemo(() => {
    if (!latestProviderRun) {
      return "Today Status\n\nNo provider directory run has been recorded yet.";
    }

    return [
      "Today Status",
      latestProviderRun?.completedAt
        ? `Run completed: ${new Date(latestProviderRun.completedAt).toLocaleString()}`
        : latestProviderRun?.startedAt
          ? `Run started: ${new Date(latestProviderRun.startedAt).toLocaleString()}`
          : "Run time: N/A",
      `New homes added: ${latestProviderRun?.newCount || 0}`,
      `Cities: ${latestProviderNewHomeCitySummary.length ? latestProviderNewHomeCitySummary.join(", ") : "None listed"}`,
      `Removed homes: ${latestProviderRun?.removedCount || 0}`,
      `Speciality: ${latestProviderNewHomeSpecialitySummary.length ? latestProviderNewHomeSpecialitySummary.join(", ") : "None listed"}`,
      "",
      "New homes",
      ...(latestProviderNewHomeLines.length ? latestProviderNewHomeLines : ["- None"]),
    ].join("\n");
  }, [
    latestProviderNewHomeCitySummary,
    latestProviderNewHomeLines,
    latestProviderNewHomeSpecialitySummary,
    latestProviderRun,
  ]);
  const providerCurrentEntriesHasMore = providerCurrentEntriesHasMoreByPage[providerCurrentEntriesPageIndex] || false;
  const providerCurrentEntriesTotalRecords = providerCurrentEntries.length === 0
    ? 0
    : (providerCurrentEntriesPageIndex * providerCurrentEntriesPageSize) + providerCurrentEntries.length + (providerCurrentEntriesHasMore ? 1 : 0);
  const nurseCurrentActiveCount = latestNurseRun?.rowCount || nurseCurrentEntries.filter((entry) => entry.active !== false).length;

  const getAuditActorLabel = (event: any) => event?.email || event?.userName || event?.userId || "Unknown user";
  const getAuditUserColumnLabel = (event: any) => event?.email || event?.userName || event?.userId || "Unknown";

  const copyProviderTodayStatusSummary = async () => {
    try {
      await navigator.clipboard.writeText(providerTodayStatusSummary);
      toast.current?.show({ severity: "success", summary: "Copied", detail: "Today Status copied to clipboard.", life: 2500 });
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: "Copy failed", detail: error?.message || "Unable to copy Today Status.", life: 3000 });
    }
  };

  const getAuditTimelineTone = (event: any): "info" | "success" | "warning" | "danger" | "neutral" => {
    const eventType = String(event?.eventType || "").toUpperCase();
    const status = String(event?.status || "").toUpperCase();

    if (status === "FAILED" || eventType.includes("ERROR") || eventType.includes("FAILED")) {
      return "danger";
    }

    if (eventType.includes("COMPLETED") || eventType.includes("CREATED") || eventType.includes("UPDATED") || status === "SUCCESS") {
      return "success";
    }

    if (eventType.includes("PAYMENT") || eventType.includes("REQUESTED") || eventType.includes("CLICK") || eventType.includes("DELETED")) {
      return "warning";
    }

    if (eventType.includes("PAGE_VIEW") || eventType.includes("OPEN") || eventType.includes("VIEW")) {
      return "info";
    }

    return "neutral";
  };

  const getAuditTimelineToneStyles = (tone: "info" | "success" | "warning" | "danger" | "neutral") => {
    if (tone === "danger") {
      return { dot: "#dc2626", bg: "#fef2f2", border: "#fecaca", text: "#991b1b" };
    }
    if (tone === "success") {
      return { dot: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0", text: "#166534" };
    }
    if (tone === "warning") {
      return { dot: "#d97706", bg: "#fff7ed", border: "#fed7aa", text: "#9a3412" };
    }
    if (tone === "info") {
      return { dot: "#2563eb", bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8" };
    }
    return { dot: "#64748b", bg: "#f8fafc", border: "#e2e8f0", text: "#475569" };
  };

  const normalizeTimelineLabel = (value: any) =>
    String(value || "")
      .replace(/\s+/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/([a-z])((resident|home|profile|details|document|documents|reminder|billing|payment|summary|assessment|website|dialog|button)\b)/gi, "$1 $2")
      .trim();

  const getFriendlyAuditAction = (event: any) => {
    const eventType = String(event?.eventType || "").toUpperCase();
    const metadata = event?.metadata || {};
    const action = normalizeTimelineLabel(String(metadata?.action || "").replace(/_/g, " ").trim());

    const eventMap: Record<string, string> = {
      HOME_CREATED: "Created home",
      HOME_DELETED: "Deleted home",
      RESIDENT_CREATED: "Added resident",
      RESIDENT_DELETED: "Deleted resident",
      DOCUMENT_UPLOADED: "Uploaded document",
      DOCUMENT_DELETED: "Deleted document",
      FOLDER_CREATED: "Created folder",
      FOLDER_DELETED: "Deleted folder",
      FOLDER_SHARED: "Shared folder",
      FOLDER_UNSHARED: "Removed folder sharing",
      REMINDER_CREATED: "Created reminder",
      REMINDER_UPDATED: "Updated reminder",
      REMINDER_DELETED: "Deleted reminder",
      WEBSITE_PUBLISHED: "Published website",
      WEBSITE_VISIBILITY_UPDATED: "Updated website visibility",
      WEBSITE_URL_UPDATED: "Updated website URL",
      STAFF_ADDED_TO_HOME: "Added staff to facility",
      STAFF_INVITATION_EMAIL_SENT: "Sent staff invitation email",
      ASSESSMENT_SUMMARY_REQUESTED: "Started assessment summary",
      ASSESSMENT_SUMMARY_COMPLETED: "Completed assessment summary",
      ASSESSMENT_COMPARE_REQUESTED: "Started assessment compare",
      ASSESSMENT_COMPARE_COMPLETED: "Completed assessment compare",
      CARE_PLAN_COMPARE_REQUESTED: "Started care plan compare",
      CARE_PLAN_COMPARE_COMPLETED: "Completed care plan compare",
      NCP_GENERATION_REQUESTED: "Started care plan generation",
      NCP_DOCUMENT_GENERATED: "Generated care plan document",
      BILLING_SETUP_INTENT_CREATED: "Started payment setup",
      BILLING_SUBSCRIPTION_CREATED: "Created subscription",
      BILLING_SUBSCRIPTION_UPDATED: "Updated subscription",
      BILLING_PAYMENT_INTENT_CREATED: "Started payment",
      BILLING_SAVED_PAYMENT_CHARGED: "Charged saved payment method",
      BILLING_PAYMENT_FINALIZED: "Finalized payment",
      BILLING_PAYMENT_METHOD_UPDATE_STARTED: "Started payment method update",
      BILLING_PAYMENT_METHOD_UPDATED: "Updated payment method",
      BILLING_PAYMENT_RETRY_REQUESTED: "Retried payment",
      BILLING_SUBSCRIPTION_CANCEL_SCHEDULED: "Scheduled subscription cancelation",
      BILLING_SUBSCRIPTION_CANCELED_NOW: "Canceled subscription",
      BILLING_SUBSCRIPTION_RESUMED: "Resumed subscription",
      FRONTEND_PAGE_VIEW: "Opened page",
      FRONTEND_UI_CLICK: action ? `Clicked ${action}` : "Clicked button",
      FRONTEND_JS_ERROR: "Hit client-side error",
      FRONTEND_API_FAILURE: "Triggered frontend API failure",
    };

    return eventMap[eventType] || eventType.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getAuditResourceLabel = (event: any) => {
    const metadata = event?.metadata || {};
    return normalizeTimelineLabel(event?.resourceName
      || metadata?.label
      || metadata?.pathname
      || metadata?.page
      || event?.resourceId
      || event?.homeId
      || event?.residentId
      || "General activity");
  };

  const currentAuditEventsPage = auditEventPages[auditEventPageIndex] || auditEvents;
  const filteredCurrentAuditEvents = React.useMemo(() => {
    const items = currentAuditEventsPage?.items || [];
    const normalizedExcludeTerms = String(auditEventExcludeText || "")
      .split(",")
      .map((term) => term.trim().toLowerCase())
      .filter(Boolean);
    if (!normalizedExcludeTerms.length) {
      return items;
    }

    return items.filter((event: any) => {
      const haystack = [
        event?.email,
        event?.userName,
        event?.userId,
        event?.resourceName,
        event?.resourceId,
        event?.homeId,
        event?.residentId,
        event?.message,
        event?.eventType,
        event?.service,
        event?.metadata ? JSON.stringify(event.metadata) : "",
      ]
        .map((value) => String(value || "").toLowerCase())
        .join(" ");

      return !normalizedExcludeTerms.some((term) => haystack.includes(term));
    });
  }, [currentAuditEventsPage, auditEventExcludeText]);

  const currentAuditTimelineItems = React.useMemo(() => {
    const items = filteredCurrentAuditEvents;
    const normalizedSearch = String(auditEventSearch || "").trim().toLowerCase();
    if (!normalizedSearch) {
      return [];
    }

    const filteredItems = items
      .filter((event: any) => {
        const actor = getAuditActorLabel(event).toLowerCase();
        const userId = String(event?.userId || "").toLowerCase();
        return actor.includes(normalizedSearch) || userId.includes(normalizedSearch);
      })
      .sort((first: any, second: any) => {
        const firstTime = first?.timestamp ? new Date(first.timestamp).getTime() : 0;
        const secondTime = second?.timestamp ? new Date(second.timestamp).getTime() : 0;
        return firstTime - secondTime;
      });

    const groupedItems: any[] = [];
    for (const event of filteredItems) {
      const timestampValue = event?.timestamp ? new Date(event.timestamp).getTime() : 0;
      const previousItem = groupedItems[groupedItems.length - 1];
      const sameAction = previousItem && previousItem.eventType === event?.eventType && previousItem.resourceLabel === getAuditResourceLabel(event);
      const closeInTime = previousItem && Math.abs(timestampValue - previousItem.timestampValue) <= 60_000;

      if (sameAction && closeInTime) {
        previousItem.count += 1;
        previousItem.lastTimestamp = event?.timestamp || previousItem.lastTimestamp;
        continue;
      }

      groupedItems.push({
        id: `${event?.timestamp || "na"}-${event?.eventType || "event"}-${groupedItems.length}`,
        eventType: event?.eventType,
        actor: getAuditActorLabel(event),
        timestamp: event?.timestamp,
        timestampValue,
        lastTimestamp: event?.timestamp,
        status: event?.status,
        service: event?.service,
        actionLabel: getFriendlyAuditAction(event),
        resourceLabel: getAuditResourceLabel(event),
        message: event?.message,
        metadata: event?.metadata,
        tone: getAuditTimelineTone(event),
        count: 1,
      });
    }

    return groupedItems;
  }, [filteredCurrentAuditEvents, auditEventSearch]);

  const isAlarmActive = (state?: string) => String(state || "").toUpperCase() === "ALARM";

  const isErrorLogMessage = (message?: string) => {
    const normalizedMessage = String(message || "").toLowerCase();
    return normalizedMessage.includes("error")
      || normalizedMessage.includes("exception")
      || normalizedMessage.includes("failed")
      || normalizedMessage.includes("denied")
      || normalizedMessage.includes("timeout");
  };

  const renderAlarmState = (data: any) => {
    const active = isAlarmActive(data.state);
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.35rem",
          padding: "0.28rem 0.65rem",
          borderRadius: "999px",
          fontWeight: 700,
          background: active ? "#fef2f2" : "#ecfdf5",
          color: active ? "#b91c1c" : "#166534",
          border: `1px solid ${active ? "#fecaca" : "#bbf7d0"}`,
        }}
      >
        <i className={active ? "pi pi-exclamation-triangle" : "pi pi-check-circle"} />
        {data.state}
      </span>
    );
  };

  const renderAlarmRow = (data: any) => ({
    backgroundColor: isAlarmActive(data.state) ? "#fef2f2" : undefined,
  });

  const getSortedAlarmItems = (items?: any[]) =>
    [...(items || [])].sort((first, second) => {
      const firstRank = isAlarmActive(first?.state) ? 0 : 1;
      const secondRank = isAlarmActive(second?.state) ? 0 : 1;
      if (firstRank !== secondRank) {
        return firstRank - secondRank;
      }

      const firstUpdatedAt = first?.updatedAt ? new Date(first.updatedAt).getTime() : 0;
      const secondUpdatedAt = second?.updatedAt ? new Date(second.updatedAt).getTime() : 0;
      return secondUpdatedAt - firstUpdatedAt;
    });

  const renderActivityMessage = (data: any) => {
    const isError = isErrorLogMessage(data.message);
    return (
      <div
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          color: isError ? "#b91c1c" : "#0f172a",
          fontWeight: isError ? 700 : 400,
        }}
      >
        {data.message}
      </div>
    );
  };

  const renderActivityRow = (data: any) => ({
    backgroundColor: isErrorLogMessage(data.message) ? "#fef2f2" : undefined,
  });

  const activityLogRanges = [
    { label: "Last 1 hour", value: "1h" },
    { label: "Last 6 hours", value: "6h" },
    { label: "Last 1 day", value: "1d" },
    { label: "Last 2 days", value: "2d" },
    { label: "Last 1 week", value: "1w" },
    { label: "Last 1 month", value: "1m" },
  ];

  const auditEventTypes = [
    { label: "All actions", value: "" },
    { label: "Home Created", value: "HOME_CREATED" },
    { label: "Home Deleted", value: "HOME_DELETED" },
    { label: "Resident Created", value: "RESIDENT_CREATED" },
    { label: "Resident Deleted", value: "RESIDENT_DELETED" },
    { label: "Document Uploaded", value: "DOCUMENT_UPLOADED" },
    { label: "Document Deleted", value: "DOCUMENT_DELETED" },
    { label: "Folder Created", value: "FOLDER_CREATED" },
    { label: "Folder Deleted", value: "FOLDER_DELETED" },
    { label: "Folder Shared", value: "FOLDER_SHARED" },
    { label: "Folder Unshared", value: "FOLDER_UNSHARED" },
    { label: "Reminder Created", value: "REMINDER_CREATED" },
    { label: "Reminder Updated", value: "REMINDER_UPDATED" },
    { label: "Reminder Deleted", value: "REMINDER_DELETED" },
    { label: "Website Published", value: "WEBSITE_PUBLISHED" },
    { label: "Website Visibility Updated", value: "WEBSITE_VISIBILITY_UPDATED" },
    { label: "Website URL Updated", value: "WEBSITE_URL_UPDATED" },
    { label: "Home Link Created", value: "HOME_LINK_CREATED" },
    { label: "Home Link Deleted", value: "HOME_LINK_DELETED" },
    { label: "Staff Added to Facility", value: "STAFF_ADDED_TO_HOME" },
    { label: "Staff Invitation Email Sent", value: "STAFF_INVITATION_EMAIL_SENT" },
    { label: "Assessment Summary Requested", value: "ASSESSMENT_SUMMARY_REQUESTED" },
    { label: "Assessment Summary Completed", value: "ASSESSMENT_SUMMARY_COMPLETED" },
    { label: "Assessment Compare Requested", value: "ASSESSMENT_COMPARE_REQUESTED" },
    { label: "Assessment Compare Completed", value: "ASSESSMENT_COMPARE_COMPLETED" },
    { label: "Care Plan Compare Requested", value: "CARE_PLAN_COMPARE_REQUESTED" },
    { label: "Care Plan Compare Completed", value: "CARE_PLAN_COMPARE_COMPLETED" },
    { label: "Billing Setup Intent Created", value: "BILLING_SETUP_INTENT_CREATED" },
    { label: "Billing Subscription Created", value: "BILLING_SUBSCRIPTION_CREATED" },
    { label: "Billing Subscription Updated", value: "BILLING_SUBSCRIPTION_UPDATED" },
    { label: "Billing Payment Intent Created", value: "BILLING_PAYMENT_INTENT_CREATED" },
    { label: "Billing Saved Payment Charged", value: "BILLING_SAVED_PAYMENT_CHARGED" },
    { label: "Billing Payment Finalized", value: "BILLING_PAYMENT_FINALIZED" },
    { label: "Billing Payment Method Update Started", value: "BILLING_PAYMENT_METHOD_UPDATE_STARTED" },
    { label: "Billing Payment Method Updated", value: "BILLING_PAYMENT_METHOD_UPDATED" },
    { label: "Billing Payment Retry Requested", value: "BILLING_PAYMENT_RETRY_REQUESTED" },
    { label: "Billing Subscription Cancel Scheduled", value: "BILLING_SUBSCRIPTION_CANCEL_SCHEDULED" },
    { label: "Billing Subscription Canceled Now", value: "BILLING_SUBSCRIPTION_CANCELED_NOW" },
    { label: "Billing Subscription Resumed", value: "BILLING_SUBSCRIPTION_RESUMED" },
    { label: "Billing Webhook Subscription Created", value: "BILLING_WEBHOOK_SUBSCRIPTION_CREATED" },
    { label: "Billing Webhook Subscription Updated", value: "BILLING_WEBHOOK_SUBSCRIPTION_UPDATED" },
    { label: "Billing Webhook Subscription Deleted", value: "BILLING_WEBHOOK_SUBSCRIPTION_DELETED" },
    { label: "Billing Webhook Subscription Resumed", value: "BILLING_WEBHOOK_SUBSCRIPTION_RESUMED" },
    { label: "Billing Webhook Payment Succeeded", value: "BILLING_WEBHOOK_PAYMENT_SUCCEEDED" },
    { label: "Billing Webhook Payment Failed", value: "BILLING_WEBHOOK_PAYMENT_FAILED" },
    { label: "Billing Webhook Invoice Payment Failed", value: "BILLING_WEBHOOK_INVOICE_PAYMENT_FAILED" },
    { label: "Billing Webhook Invoice Payment Succeeded", value: "BILLING_WEBHOOK_INVOICE_PAYMENT_SUCCEEDED" },
    { label: "NCP Requested", value: "NCP_GENERATION_REQUESTED" },
    { label: "NCP Document Generated", value: "NCP_DOCUMENT_GENERATED" },
    { label: "Frontend Page View", value: "FRONTEND_PAGE_VIEW" },
    { label: "Frontend Button Click", value: "FRONTEND_UI_CLICK" },
    { label: "Frontend JS Error", value: "FRONTEND_JS_ERROR" },
    { label: "Frontend API Failure", value: "FRONTEND_API_FAILURE" },
  ];

  const auditEventStatuses = [
    { label: "All statuses", value: "" },
    { label: "Success", value: "SUCCESS" },
    { label: "Failed", value: "FAILED" },
  ];
  const adminButtonProps = {
    severity: "warning" as const,
    outlined: true,
    rounded: true,
  };
  const shouldShowAdminSection = (action: AdminToolbarAction) => activeAdminAction === action;

  const resetDemoSlotForm = () => {
    setDemoFeatureNotesTouched(false);
    setDemoSlotForm({
      slotId: "",
      slotDate: "",
      startTime: "",
      endTime: "",
      capacity: 5,
      status: "open",
      demoTitle: "",
      selectedFeatures: [],
      customFeatureNotes: "",
      meetingLink: "",
      notes: "",
    });
  };

  const loadDemoScheduler = async () => {
    setDemoSchedulerLoading(true);
    try {
      const result = await backendAPIStore.getDemoAdminData();
      setDemoSlots(Array.isArray(result?.slots) ? result.slots : []);
      setDemoFeatureOptions(Array.isArray(result?.featureOptions) ? result.featureOptions : []);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setDemoSchedulerLoading(false);
    }
  };

  const onShowDemoScheduler = async () => {
    setActiveAdminAction("demo");
    await loadDemoScheduler();
  };

  const openCreateDemoSlotDialog = () => {
    resetDemoSlotForm();
    setShowDemoSlotDialog(true);
  };

  const openEditDemoSlotDialog = (slot: any) => {
    setDemoFeatureNotesTouched(false);
    setDemoSlotForm({
      slotId: String(slot?.slotId || ""),
      slotDate: String(slot?.slotDate || ""),
      startTime: String(slot?.startTime || ""),
      endTime: String(slot?.endTime || ""),
      capacity: Number(slot?.capacity || 5),
      status: String(slot?.status || "open"),
      demoTitle: String(slot?.demoTitle || ""),
      selectedFeatures: Array.isArray(slot?.selectedFeatures) ? slot.selectedFeatures : [],
      customFeatureNotes: String(slot?.customFeatureNotes || ""),
      meetingLink: String(slot?.meetingLink || ""),
      notes: String(slot?.notes || ""),
    });
    setShowDemoSlotDialog(true);
  };

  const generateDemoFeatureNotesForSelection = async (nextSelectedFeatures?: string[], nextDemoTitle?: string) => {
    const selectedFeatures = Array.isArray(nextSelectedFeatures) ? nextSelectedFeatures : (demoSlotForm.selectedFeatures || []);
    const demoTitle = typeof nextDemoTitle === "string" ? nextDemoTitle : String(demoSlotForm.demoTitle || "");
    if ((selectedFeatures || []).length === 0) {
      setDemoSlotForm((current: any) => ({ ...current, customFeatureNotes: "" }));
      setDemoFeatureNotesTouched(false);
      return;
    }

    setGeneratingDemoFeatureNotes(true);
    try {
      const response = await backendAPIStore.generateDemoFeatureNotes({
        demoTitle,
        selectedFeatures,
      });
      setDemoSlotForm((current: any) => ({
        ...current,
        customFeatureNotes: String(response?.customFeatureNotes || "").trim(),
      }));
      setDemoFeatureNotesTouched(false);
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setGeneratingDemoFeatureNotes(false);
    }
  };

  const openDemoRegistrationsDialog = (slot: any) => {
    setSelectedDemoSlot(slot);
    setShowDemoRegistrationsDialog(true);
  };

  const saveDemoSlot = async () => {
    setSavingDemoSlot(true);
    try {
      if (demoSlotForm?.slotId) {
        await backendAPIStore.updateDemoSlot(demoSlotForm);
      } else {
        await backendAPIStore.createDemoSlot(demoSlotForm);
      }
      setShowDemoSlotDialog(false);
      await loadDemoScheduler();
    } catch (error: any) {
      toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
    } finally {
      setSavingDemoSlot(false);
    }
  };

  const onCancelDemoSlot = (slot: any) => {
    confirmDialog({
      message: "Cancel this demo slot and notify booked attendees?",
      header: "Cancel Demo Slot",
      acceptClassName: "p-button-warning",
      accept: () => void (async () => {
        try {
          await backendAPIStore.cancelDemoSlot(String(slot?.slotId || ""));
          await loadDemoScheduler();
        } catch (error: any) {
          toast.current?.show({ severity: "error", summary: getErrorTitle(error), detail: error.message, life: 3000 });
        }
      })(),
    });
  };

  const copyDemoSlotLink = async (slot: any) => {
    const slotId = String(slot?.slotId || "").trim();
    if (!slotId) {
      return;
    }
    const demoLink = `${window.location.origin}/book-demo?slotId=${encodeURIComponent(slotId)}`;
    try {
      await navigator.clipboard.writeText(demoLink);
      toast.current?.show({
        severity: "success",
        summary: "Demo link copied",
        detail: "The public demo link is ready to share.",
        life: 2500,
      });
    } catch (error: any) {
      toast.current?.show({
        severity: "warn",
        summary: "Copy failed",
        detail: demoLink,
        life: 5000,
      });
    }
  };

  const monitoringRanges = [
    { label: "Last 1 hour", value: "1h" },
    { label: "Last 6 hours", value: "6h" },
    { label: "Last 12 hours", value: "12h" },
    { label: "Last 1 day", value: "1d" },
    { label: "Last 2 days", value: "2d" },
    { label: "Last 1 week", value: "1w" },
  ];

  const inviteStatusCounts = platformInvites.reduce((acc: Record<string, number>, invite: any) => {
    const status = String(invite?.status || "pending").trim().toLowerCase();
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  if (initializing) {
    return (
      <div className="card flex justify-content-center p-5" style={{ ...dashboardSectionCardStyle, margin: mobile ? "1rem" : "1.25rem" }}>
        <ProgressSpinner role="status" style={{ color: "#185DA2" }} />
      </div>
    );
  }

  if (!userGroups.includes(USER_GROUP_ADMIN)) {
    return <Unauthorized />;
  }

  return (
    <div style={{ padding: mobile ? "1rem" : "1.25rem" }}>
      <Toast ref={toast} />
      <div style={dashboardPageContainerStyle}>
        {renderDashboardHeader(
          "Admin Workspace",
          "Use this private area for platform operations, reporting, and future admin-only tools.",
        )}

        <Accordion activeIndex={activeAdminAction === "binder" ? 1 : 0}>
          <AccordionTab
            headerTemplate={() => renderSurfaceHeader(
              "Operations Console",
              "Review users, subscriptions, and customer feedback from one workspace.",
              "pi pi-shield",
            )}
          >
            <div style={dashboardSectionCardStyle}>
              <div style={{ ...appAccentPanelStyle, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
                <div className="flex flex-wrap justify-content-between align-items-center gap-3">
                  <div>
                    <div style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}>Admin Tools</div>
                    <div className="mt-2" style={appMutedTextStyle}>
                      Load the current user directory, subscription metrics, and recent customer feedback.
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <Button label="View Invites" {...adminButtonProps} loading={platformInvitesLoading} onClick={onShowInviteActivity} />
                    <Button label="Load Metrics" {...adminButtonProps} loading={observabilityLoading} onClick={onLoadObservabilitySummary} />
                    <Button label="Load Activity Logs" {...adminButtonProps} loading={activityLogsLoading} onClick={onLoadActivityLogs} />
                    <Button label="View Users" {...adminButtonProps} loading={adminUserListLoading} onClick={onAdminListUsers} />
                    <Button label="View Feedback" {...adminButtonProps} loading={customerFeedbacksLoading} onClick={onAdminGetCustomerFeedbacks} />
                    <Button label="Email Users" {...adminButtonProps} onClick={openEmailCampaignDialog} />
                    <Button label="Demo Scheduler" {...adminButtonProps} loading={demoSchedulerLoading} onClick={() => void onShowDemoScheduler()} />
                    <Button label="Provider Directory" {...adminButtonProps} loading={providerDirectoryLoading} onClick={() => void onShowProviderDirectory()} />
                    <Button label="Nurse Directory" {...adminButtonProps} loading={providerDirectoryLoading} onClick={() => void onShowNurseDirectory()} />
                    <Button label="Binder Tools" {...adminButtonProps} onClick={onShowBinderTools} />
                    <Button label="Fax Activity" {...adminButtonProps} onClick={() => setActiveAdminAction("fax")} />
                    {activeAdminAction ? (
                      <Button label="Clear Selection" {...adminButtonProps} onClick={() => setActiveAdminAction(null)} />
                    ) : null}
                  </div>
                </div>
              </div>

              <div style={{ padding: "1.25rem" }}>
                {!activeAdminAction ? (
                  <div style={appNeutralPanelStyle}>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>Choose an admin tool</div>
                    <div className="mt-2" style={appMutedTextStyle}>
                      Sections stay hidden until you click an action above, so the workspace stays lighter and easier to scan.
                    </div>
                  </div>
                ) : null}

                {shouldShowAdminSection("invites") ? (
                  <div className="mb-4">
                    <div className="mb-3">
                      {renderSurfaceHeader("Invite Activity", "Track how many AFH Hub invitations have been sent and review the latest invite details.", "pi pi-megaphone")}
                    </div>
                    <div className="grid mb-3">
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Total Invites Sent", platformInvites.length, "accent")}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Pending", inviteStatusCounts.pending || 0)}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Accepted", inviteStatusCounts.accepted || 0)}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Expired / Canceled", (inviteStatusCounts.expired || 0) + (inviteStatusCounts.canceled || 0))}
                      </div>
                    </div>
                    <div style={appDataTableWrapperStyle}>
                      <DataTable
                        value={[...platformInvites].sort((first: any, second: any) => String(second.createdAt || "").localeCompare(String(first.createdAt || "")))}
                        className="p-datatable-sm p-datatable-striped"
                        loading={platformInvitesLoading}
                        emptyMessage="No AFH Hub invites sent yet."
                      >
                        <Column field="targetName" header="Invitee" body={(data) => data.targetName || "Unknown"} />
                        <Column field="targetEmail" header="Email" />
                        <Column field="suggestedRoleType" header="Suggested Role" body={(data) => data.suggestedRoleType ? String(data.suggestedRoleType).replace(/_/g, " ").replace(/\b\w/g, (char: string) => char.toUpperCase()) : "User"} />
                        <Column field="inviterDisplayName" header="Invited By" body={(data) => data.inviterDisplayName || data.inviterEmail || "Unknown"} />
                        <Column field="inviterEmail" header="Invited By Email" body={(data) => data.inviterEmail || "N/A"} />
                        <Column field="status" header="Status" body={(data) => String(data.status || "pending").replace(/\b\w/g, (char: string) => char.toUpperCase())} />
                        <Column field="createdAt" header="Sent" body={(data) => data.createdAt ? new Date(data.createdAt).toLocaleString() : "N/A"} />
                        <Column field="expiresAt" header="Expires" body={(data) => data.expiresAt ? new Date(data.expiresAt).toLocaleDateString() : "N/A"} />
                      </DataTable>
                    </div>
                  </div>
                ) : null}

                {shouldShowAdminSection("fax") ? (
                  <div className="mb-4">
                    <FaxAuditHistoryPage scope="admin" embedded />
                  </div>
                ) : null}

                {shouldShowAdminSection("demo") ? (
                  <div className="mb-4">
                    <div className="mb-3">
                      {renderSurfaceHeader("Demo Scheduler", "Create demo slots for any past or future date, choose the product topics for each session, and review who has booked each demo.", "pi pi-calendar")}
                    </div>
                    <div style={{ ...appNeutralPanelStyle, marginBottom: "1rem" }}>
                      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
                        <div style={appMutedTextStyle}>
                          Public demo bookings use America/Los_Angeles time and stay available for signed-in and unsigned users from the same booking page.
                        </div>
                        <div className="flex flex-wrap gap-2">
                          <Button label="Refresh" {...adminButtonProps} loading={demoSchedulerLoading} onClick={() => void loadDemoScheduler()} />
                          <Button label="New Demo Slot" {...adminButtonProps} onClick={openCreateDemoSlotDialog} />
                        </div>
                      </div>
                    </div>
                    <div style={appDataTableWrapperStyle}>
                      <DataTable
                        value={demoSlots}
                        className="p-datatable-sm p-datatable-striped"
                        loading={demoSchedulerLoading}
                        emptyMessage="No demo slots have been created yet."
                      >
                        <Column field="demoTitle" header="Demo" body={(data) => data.demoTitle || "General Product Demo"} />
                        <Column field="dateTimeLabel" header="When" />
                        <Column field="capacity" header="Capacity" body={(data) => Number(data.capacity || 0)} />
                        <Column field="bookedCount" header="Booked" body={(data) => Number(data.bookedCount || 0)} />
                        <Column field="cancelledCount" header="Cancelled" body={(data) => Number(data.cancelledCount || 0)} />
                        <Column field="seatsRemaining" header="Seats Left" body={(data) => Number(data.seatsRemaining || 0)} />
                        <Column
                          field="status"
                          header="Status"
                          body={(data) => (
                            <Tag
                              value={String(data?.status || "open").toUpperCase()}
                              severity={data?.status === "cancelled" ? "danger" : data?.status === "full" ? "warning" : "success"}
                            />
                          )}
                        />
                        <Column
                          field="selectedFeatures"
                          header="Topics"
                          body={(data) => (
                            <div style={{ maxWidth: "18rem", whiteSpace: "normal" }}>
                              {(Array.isArray(data?.selectedFeatures) ? data.selectedFeatures : []).join(", ") || data?.customFeatureNotes || "General Product Demo"}
                            </div>
                          )}
                        />
                        <Column
                          field="meetingLink"
                          header="Meeting"
                          body={(data) => {
                            const meetingLink = String(data?.meetingLink || "").trim();
                            if (!meetingLink) {
                              return "Not set";
                            }
                            return (
                              <Button
                                label="Open Link"
                                {...adminButtonProps}
                                size="small"
                                onClick={() => window.open(meetingLink, "_blank", "noopener,noreferrer")}
                              />
                            );
                          }}
                        />
                        <Column
                          header="Actions"
                          body={(data) => (
                            <div className="flex flex-wrap gap-2">
                              <Button label="Copy Link" {...adminButtonProps} size="small" onClick={() => void copyDemoSlotLink(data)} />
                              <Button label="Signups" {...adminButtonProps} size="small" onClick={() => openDemoRegistrationsDialog(data)} />
                              <Button label="Edit" {...adminButtonProps} size="small" onClick={() => openEditDemoSlotDialog(data)} />
                              <Button label="Cancel" severity="danger" outlined rounded size="small" disabled={String(data?.status || "") === "cancelled"} onClick={() => onCancelDemoSlot(data)} />
                            </div>
                          )}
                        />
                      </DataTable>
                    </div>
                  </div>
                ) : null}

                {shouldShowAdminSection("providerDirectory") ? (
                  <div className="mb-4">
                    <div className="mb-3">
                      {renderSurfaceHeader("Provider Directory", "Import the statewide AFH provider file daily, review run history, and inspect detected changes.", "pi pi-building-columns")}
                    </div>
                    <div style={{ ...appNeutralPanelStyle, marginBottom: "1rem" }}>
                      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
                        <div style={appMutedTextStyle}>
                          Sources: DSHS AFH locator export for all counties plus per-provider report pages. Imports and report syncs run asynchronously because the source pages can take time to generate and scan.
                        </div>
                        <div className="flex flex-wrap gap-2">
                          <Button label="Refresh" {...adminButtonProps} loading={providerDirectoryLoading} onClick={() => void loadProviderDirectoryDashboard()} />
                          <Button label="Run Import Now" {...adminButtonProps} loading={providerDirectoryRunning} onClick={() => void onStartProviderDirectoryImport()} />
                          <Button label="Run Reports Sync" {...adminButtonProps} loading={providerDirectoryReportRunning} onClick={() => void onStartProviderDirectoryReportSync()} />
                        </div>
                      </div>
                    </div>
                    <div className="grid mb-4">
                      <div className="col-12">
                        <div className="mb-3">
                          {renderSurfaceHeader("Today Status", "Copy a quick social summary for the latest provider directory run.", "pi pi-megaphone")}
                        </div>
                        <div style={{ ...dashboardSectionCardStyle, boxShadow: "none" }}>
                          <div className="flex justify-content-between align-items-start gap-3 flex-wrap" style={{ marginBottom: "0.9rem" }}>
                            <div style={{ ...appMutedTextStyle, maxWidth: "48rem", lineHeight: 1.7 }}>
                              This block summarizes the latest provider directory run so it is easy to copy into a Facebook post.
                            </div>
                            <Button
                              type="button"
                              label="Copy Summary"
                              icon="pi pi-copy"
                              severity="warning"
                              rounded
                              onClick={() => { void copyProviderTodayStatusSummary(); }}
                            />
                          </div>
                          <div className="grid">
                            <div className="col-12 lg:col-6">
                              <div style={{ ...appNeutralPanelStyle, margin: 0 }}>
                                <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: "0.45rem" }}>Cities</div>
                                <div style={appMutedTextStyle}>
                                  {latestProviderNewHomeCitySummary.length ? latestProviderNewHomeCitySummary.join(", ") : "No new-home cities recorded in the latest run."}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 lg:col-6">
                              <div style={{ ...appNeutralPanelStyle, margin: 0 }}>
                                <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: "0.45rem" }}>Speciality</div>
                                <div style={appMutedTextStyle}>
                                  {latestProviderNewHomeSpecialitySummary.length ? latestProviderNewHomeSpecialitySummary.join(", ") : "No new-home specialities recorded in the latest run."}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-3">
                            <div className="mb-3">
                              {renderSurfaceHeader("New Homes By City", "Grouped view of homes added in the latest run.", "pi pi-table")}
                            </div>
                            <div style={appDataTableWrapperStyle}>
                              <DataTable
                                value={latestProviderNewHomesByCity}
                                className="p-datatable-sm p-datatable-striped"
                                emptyMessage="No new homes were added in the latest run."
                              >
                                <Column field="city" header="City" />
                                <Column field="count" header="New Homes" body={(data: any) => data.count || 0} />
                                <Column
                                  field="specialities"
                                  header="Speciality"
                                  body={(data: any) => (data.specialities || []).join(", ") || "N/A"}
                                />
                                <Column
                                  field="homes"
                                  header="Homes"
                                  body={(data: any) => (
                                    <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
                                      {(data.homes || []).map((home: string, index: number) => (
                                        <span key={`${data.city}-${home}-${index}`}>{home}</span>
                                      ))}
                                    </div>
                                  )}
                                />
                              </DataTable>
                            </div>
                          </div>
                          <div className="mt-3">
                            <InputTextarea
                              value={providerTodayStatusSummary}
                              readOnly
                              rows={Math.max(10, latestProviderNewHomeLines.length + 7)}
                              autoResize
                              style={{ width: "100%", fontFamily: "monospace", lineHeight: 1.6 }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          {renderSurfaceHeader("Recent Runs", "Track queued, running, completed, and failed import jobs.", "pi pi-history")}
                        </div>
                        <div style={appDataTableWrapperStyle}>
                          <DataTable value={providerRuns} className="p-datatable-sm p-datatable-striped" loading={providerDirectoryLoading} emptyMessage="No provider directory runs yet." paginator rows={5} rowsPerPageOptions={[5, 10, 20]}>
                            <Column field="startedAt" header="Started" body={(data: ProviderDirectoryRun) => data.startedAt ? new Date(data.startedAt).toLocaleString() : "N/A"} />
                            <Column header="Status" body={renderProviderDirectoryRunStatus} />
                            <Column field="rowCount" header="Rows" body={(data: ProviderDirectoryRun) => data.rowCount || 0} />
                            <Column field="newCount" header="New" body={(data: ProviderDirectoryRun) => data.newCount || 0} />
                            <Column field="changedCount" header="Updated" body={(data: ProviderDirectoryRun) => (data.changedCount || 0) + (data.reactivatedCount || 0)} />
                            <Column field="removedCount" header="Removed" body={(data: ProviderDirectoryRun) => data.removedCount || 0} />
                          </DataTable>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="mb-3">
                        {renderSurfaceHeader("Recent Changes", "Detected new, updated, removed, and reactivated provider records.", "pi pi-list-check")}
                      </div>
                      <div style={appDataTableWrapperStyle}>
                        <DataTable value={providerChanges} className="p-datatable-sm p-datatable-striped" loading={providerDirectoryLoading} emptyMessage="No provider directory changes detected yet." paginator rows={10}>
                          <Column field="facilityName" header="Facility" body={(data: ProviderDirectoryChange) => data.facilityName || "Unknown"} />
                          <Column field="licenseNumber" header="License #" body={(data: ProviderDirectoryChange) => data.licenseNumber || "N/A"} />
                          <Column header="Change" body={renderProviderDirectoryChangeType} />
                          <Column field="fieldDiffs" header="Changed Fields" body={renderProviderDirectoryChangedFields} />
                          <Column field="createdAt" header="Detected" body={(data: ProviderDirectoryChange) => data.createdAt ? new Date(data.createdAt).toLocaleString() : "N/A"} />
                        </DataTable>
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="mb-3 flex flex-wrap justify-content-between align-items-center gap-2">
                        {renderSurfaceHeader("Current Entries", "Browse the latest provider records with filters, paging, active status, and report availability.", "pi pi-database")}
                        <Button
                          type="button"
                          label="Download All Excel"
                          icon="pi pi-file-excel"
                          severity="success"
                          outlined
                          loading={providerDirectoryExporting}
                          disabled={providerDirectoryLoading}
                          tooltip="Download all Current Entries as an Excel workbook"
                          tooltipOptions={{ position: "left" }}
                          onClick={() => void onExportProviderDirectoryCurrentEntries()}
                        />
                      </div>
                      <div style={appDataTableWrapperStyle}>
                        <DataTable
                          value={providerCurrentEntries}
                          className="p-datatable-sm p-datatable-striped"
                          loading={providerDirectoryLoading}
                          emptyMessage="No provider directory entries imported yet."
                          rowClassName={renderProviderDirectoryCurrentEntryRow}
                          lazy
                          paginator
                          first={providerCurrentEntriesPageIndex * providerCurrentEntriesPageSize}
                          rows={providerCurrentEntriesPageSize}
                          totalRecords={providerCurrentEntriesTotalRecords}
                          rowsPerPageOptions={[25, 50, 100]}
                          paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink RowsPerPageDropdown"
                          currentPageReportTemplate={`Page ${providerCurrentEntriesPageIndex + 1}`}
                          onPage={(e) => void onProviderCurrentEntriesPage(e)}
                          filterDisplay="row"
                          filters={providerCurrentEntriesFilters}
                          onFilter={(e) => onProviderCurrentEntriesFilter(e.filters)}
                          globalFilterFields={[
                            "facilityName",
                            "facilityPOC",
                            "telephoneNumber",
                            "speciality",
                            "formattedAddress",
                            "licensedBedCount",
                            "hasReports",
                            "reportsLocation",
                          ]}
                          header={(
                            <div className="flex flex-wrap justify-content-between align-items-center gap-2">
                              <div style={appMutedTextStyle}>
                                Showing paged provider records from DynamoDB, with backend-backed search and filters.
                              </div>
                              <InputText
                                value={providerCurrentEntriesGlobalFilter}
                                onChange={(e) => onProviderCurrentEntriesGlobalFilterChange(e.target.value)}
                                placeholder="Search POC, contact, speciality, address, bed count, or reports"
                                style={{ minWidth: "20rem" }}
                              />
                            </div>
                          )}
                        >
                          <Column field="facilityName" header="AFH Name" body={(data: ProviderDirectoryEntry) => data.facilityName || "Unknown"} />
                          <Column field="licenseNumber" header="License #" body={(data: ProviderDirectoryEntry) => data.licenseNumber || "N/A"} filter filterPlaceholder="Filter license #" />
                          <Column field="disclosureOfServices" header="Disclosure of Services" body={(data: ProviderDirectoryEntry) => data.disclosureOfServices || "N/A"} />
                          <Column field="active" header="Active" body={renderProviderDirectoryActiveStatus} />
                          <Column field="facilityPOC" header="Facility POC" body={(data: ProviderDirectoryEntry) => data.facilityPOC || "N/A"} filter filterPlaceholder="Filter POC" />
                          <Column field="telephoneNumber" header="Contact" body={(data: ProviderDirectoryEntry) => data.telephoneNumber || "N/A"} filter filterPlaceholder="Filter contact" />
                          <Column field="speciality" header="Speciality" body={(data: ProviderDirectoryEntry) => data.speciality || "N/A"} filter filterPlaceholder="Filter speciality" />
                          <Column field="formattedAddress" header="Address" body={(data: ProviderDirectoryEntry) => data.formattedAddress || "N/A"} filter filterPlaceholder="Filter address" />
                          <Column field="licensedBedCount" header="Bed Count" body={(data: ProviderDirectoryEntry) => data.licensedBedCount || "N/A"} filter filterPlaceholder="Filter bed count" />
                          <Column field="hasReports" header="Has Reports" body={renderProviderDirectoryReports} filter filterPlaceholder="Filter reports" />
                          <Column field="reportPageStatus" header="Report Sync" body={renderProviderDirectoryReportStatus} />
                          <Column field="reportCategoryCounts" header="Categories" body={renderProviderDirectoryReportCategories} />
                        </DataTable>
                      </div>
                    </div>

                    {latestProviderRun?.errorSummary ? (
                      <div style={appAccentPanelStyle}>
                        <div style={{ fontWeight: 700, color: "#9a3412", marginBottom: "0.5rem" }}>Latest Run Error</div>
                        <div style={appMutedTextStyle}>{latestProviderRun.errorSummary}</div>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {shouldShowAdminSection("nurseDirectory") ? (
                  <div className="mb-4">
                    <div className="mb-3">
                      {renderSurfaceHeader("Nurse Directory", "Sync the Washington DSHS nurse delegator directory daily, review changes, and prepare dashboard verification data.", "pi pi-id-card")}
                    </div>
                    <div style={{ ...appNeutralPanelStyle, marginBottom: "1rem" }}>
                      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
                        <div style={appMutedTextStyle}>
                          Source: Washington DSHS Find Nurse Delegators directory. Syncs run asynchronously, keep a current snapshot, and flag new, updated, removed, and reactivated records for review.
                        </div>
                        <div className="flex flex-wrap gap-2">
                          <Button label="Refresh" {...adminButtonProps} loading={providerDirectoryLoading} onClick={() => void loadProviderDirectoryDashboard()} />
                          <Button label="Run Nurse Sync" {...adminButtonProps} loading={nurseDirectoryRunning} onClick={() => void onStartNurseDirectoryImport()} />
                        </div>
                      </div>
                    </div>
                    <div className="grid mb-3">
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Latest Nurse Sync", latestNurseRun?.status ? String(latestNurseRun.status).replace(/\b\w/g, (char) => char.toUpperCase()) : "Not started", "accent")}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Active Nurses", nurseCurrentActiveCount)}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("New Nurses", latestNurseRun?.newCount || 0)}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Deleted Nurses", latestNurseRun?.removedCount || 0)}
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="mb-3">
                        {renderSurfaceHeader("Nurse Directory Runs", "Track daily and manual nurse delegator sync jobs from the Washington DSHS directory.", "pi pi-history")}
                      </div>
                      <div style={appDataTableWrapperStyle}>
                        <DataTable value={nurseRuns} className="p-datatable-sm p-datatable-striped" loading={providerDirectoryLoading} emptyMessage="No nurse directory runs yet.">
                          <Column field="startedAt" header="Started" body={(data: NurseDirectoryRun) => data.startedAt ? new Date(data.startedAt).toLocaleString() : "N/A"} />
                          <Column header="Status" body={renderProviderDirectoryRunStatus as any} />
                          <Column field="rowCount" header="Rows" body={(data: NurseDirectoryRun) => data.rowCount || 0} />
                          <Column field="newCount" header="New" body={(data: NurseDirectoryRun) => data.newCount || 0} />
                          <Column field="removedCount" header="Deleted" body={(data: NurseDirectoryRun) => data.removedCount || 0} />
                        </DataTable>
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="mb-3">
                        {renderSurfaceHeader("Nurse Directory Changes", "Detected new, updated, removed, and reactivated nurse delegator records.", "pi pi-user-edit")}
                      </div>
                      <div style={appDataTableWrapperStyle}>
                        <DataTable value={nurseChanges} className="p-datatable-sm p-datatable-striped" loading={providerDirectoryLoading} emptyMessage="No nurse directory changes detected yet." paginator rows={10}>
                          <Column field="displayName" header="Name" body={(data: NurseDirectoryChange) => data.displayName || "Unknown"} />
                          <Column field="providerOneId" header="ProviderOne ID" body={(data: NurseDirectoryChange) => data.providerOneId || "N/A"} />
                          <Column header="Change" body={renderProviderDirectoryChangeType as any} />
                          <Column field="fieldDiffs" header="Changed Fields" body={(data: NurseDirectoryChange) => renderProviderDirectoryChangedFields(data as any)} />
                          <Column field="createdAt" header="Detected" body={(data: NurseDirectoryChange) => data.createdAt ? new Date(data.createdAt).toLocaleString() : "N/A"} />
                        </DataTable>
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="mb-3">
                        {renderSurfaceHeader("Current Nurses", "Latest active nurse delegator records captured from the Washington DSHS directory.", "pi pi-users")}
                      </div>
                      <div style={appDataTableWrapperStyle}>
                        <DataTable
                          value={nurseCurrentEntries}
                          className="p-datatable-sm p-datatable-striped"
                          loading={providerDirectoryLoading}
                          emptyMessage="No nurse directory entries imported yet."
                          paginator
                          rows={10}
                          filterDisplay="row"
                          filters={nurseCurrentEntriesFilters}
                          onFilter={(e) => onNurseCurrentEntriesFilter(e.filters)}
                          globalFilterFields={[
                            "displayName",
                            "email",
                          ]}
                          header={(
                            <div className="flex flex-wrap justify-content-between align-items-center gap-2">
                              <div style={appMutedTextStyle}>
                                Filter current nurse directory records by name or email.
                              </div>
                              <InputText
                                value={nurseCurrentEntriesGlobalFilter}
                                onChange={(e) => onNurseCurrentEntriesGlobalFilterChange(e.target.value)}
                                placeholder="Search name or email"
                                style={{ minWidth: "18rem" }}
                              />
                            </div>
                          )}
                        >
                          <Column field="displayName" header="Name" body={(data: NurseDirectoryEntry) => data.displayName || "Unknown"} filter filterPlaceholder="Filter name" />
                          <Column field="providerOneId" header="ProviderOne ID" body={(data: NurseDirectoryEntry) => data.providerOneId || "N/A"} />
                          <Column field="phoneNumber" header="Phone" body={(data: NurseDirectoryEntry) => data.phoneNumber || "N/A"} />
                          <Column field="email" header="Email" body={(data: NurseDirectoryEntry) => data.email || "N/A"} filter filterPlaceholder="Filter email" />
                          <Column field="countiesRaw" header="Counties" body={(data: NurseDirectoryEntry) => data.countiesRaw || "N/A"} />
                        </DataTable>
                      </div>
                    </div>

                    {latestNurseRun?.errorSummary ? (
                      <div style={appAccentPanelStyle}>
                        <div style={{ fontWeight: 700, color: "#9a3412", marginBottom: "0.5rem" }}>Latest Nurse Sync Error</div>
                        <div style={appMutedTextStyle}>{latestNurseRun.errorSummary}</div>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {shouldShowAdminSection("metrics") && observabilitySummary ? (
                  <div className="mb-4">
                    <div className="mb-3">
                      {renderSurfaceHeader("Observability Dashboard", "Frontend telemetry, backend health, and alarm state for the selected time window.", "pi pi-chart-line")}
                    </div>
                    <div style={{ ...appNeutralPanelStyle, marginBottom: "1rem" }}>
                      <div className="grid">
                        <div className="col-12 md:col-4">
                          <label htmlFor="monitoringRange" className="block mb-2" style={{ fontWeight: 600, color: "#0f172a" }}>Monitoring Timeline</label>
                          <Dropdown
                            id="monitoringRange"
                            value={observabilityRange}
                            options={monitoringRanges}
                            onChange={(e) => setObservabilityRange(e.value)}
                            optionLabel="label"
                            optionValue="value"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-12 md:col-4 flex align-items-end">
                          <Button label="Refresh Monitoring" {...adminButtonProps} loading={observabilityLoading} onClick={onLoadObservabilitySummary} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 md:col-4 flex align-items-end">
                          <div style={{ ...appMutedTextStyle, paddingBottom: "0.5rem" }}>
                            Current window: {monitoringRanges.find((item) => item.value === (observabilitySummary.range || observabilityRange))?.label || observabilitySummary.windowHours}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid mb-3">
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Frontend Page Views", observabilitySummary.frontend?.pageViews || 0, "accent")}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Frontend Button Clicks", observabilitySummary.frontend?.uiClicks || 0)}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Frontend API Failures", observabilitySummary.frontend?.apiFailures || 0)}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Frontend JS Errors", observabilitySummary.frontend?.jsErrors || 0)}
                      </div>
                      <div className="col-12 md:col-3">
                        {renderMetricCard("Active Alarms", observabilitySummary.alarms?.active || 0)}
                      </div>
                    </div>
                    <div className="grid mb-4">
                      <div className="col-12 lg:col-6">
                        <div className="mb-3">
                          {renderSurfaceHeader("Backend Lambdas", "Errors, invocations, and average duration.", "pi pi-server")}
                        </div>
                        <div style={appDataTableWrapperStyle}>
                          <DataTable value={observabilitySummary.backend?.lambdas || []} className="p-datatable-sm p-datatable-striped">
                            <Column field="label" header="Service" />
                            <Column field="errors" header="Errors" />
                            <Column field="invocations" header="Invocations" />
                            <Column field="avgDurationMs" header="Avg Duration (ms)" />
                          </DataTable>
                        </div>
                      </div>
                      <div className="col-12 lg:col-6">
                        <div className="mb-3">
                          {renderSurfaceHeader("APIs", "Server-side API Gateway 5xx counts.", "pi pi-globe")}
                        </div>
                        <div style={appDataTableWrapperStyle}>
                          <DataTable value={observabilitySummary.backend?.apis || []} className="p-datatable-sm p-datatable-striped">
                            <Column field="label" header="API" />
                            <Column field="serverErrors" header="5xx Errors" />
                          </DataTable>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="mb-3">
                        {renderSurfaceHeader("Alarm State", "Current CloudWatch alarm states.", "pi pi-bell")}
                      </div>
                      <div style={appDataTableWrapperStyle}>
                        <DataTable value={getSortedAlarmItems(observabilitySummary.alarms?.items)} className="p-datatable-sm p-datatable-striped" emptyMessage="No alarms configured yet." rowClassName={renderAlarmRow}>
                          <Column field="name" header="Alarm" />
                          <Column field="state" header="State" body={renderAlarmState} />
                          <Column field="updatedAt" header="Updated" body={(data) => data.updatedAt ? new Date(data.updatedAt).toLocaleString() : "N/A"} />
                          <Column field="reason" header="Reason" />
                        </DataTable>
                      </div>
                    </div>
                  </div>
                ) : null}

                {shouldShowAdminSection("activity") ? (
                  <div className="mb-4">
                    <div className="mb-3">
                      {renderSurfaceHeader("Structured Audit Events", "Review important user actions like homes, residents, documents, and NCP workflows with filters by user and action type.", "pi pi-list-check")}
                    </div>
                    <div style={{ ...appNeutralPanelStyle, marginBottom: "1rem" }}>
                      <div className="grid">
                        <div className="col-12 md:col-3">
                          <label htmlFor="auditEventRange" className="block mb-2" style={{ fontWeight: 600, color: "#0f172a" }}>Time Window</label>
                          <Dropdown
                            id="auditEventRange"
                            value={auditEventRange}
                            options={activityLogRanges}
                            onChange={(e) => setAuditEventRange(e.value)}
                            optionLabel="label"
                            optionValue="value"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-12 md:col-3">
                          <label htmlFor="auditEventType" className="block mb-2" style={{ fontWeight: 600, color: "#0f172a" }}>Action Type</label>
                          <Dropdown
                            id="auditEventType"
                            value={auditEventType}
                            options={auditEventTypes}
                            onChange={(e) => setAuditEventType(e.value)}
                            optionLabel="label"
                            optionValue="value"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-12 md:col-2">
                          <label htmlFor="auditEventStatus" className="block mb-2" style={{ fontWeight: 600, color: "#0f172a" }}>Status</label>
                          <Dropdown
                            id="auditEventStatus"
                            value={auditEventStatus}
                            options={auditEventStatuses}
                            onChange={(e) => setAuditEventStatus(e.value)}
                            optionLabel="label"
                            optionValue="value"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-12 md:col-3">
                          <label htmlFor="auditEventSearch" className="block mb-2" style={{ fontWeight: 600, color: "#0f172a" }}>User / Email / Resource Filter</label>
                          <InputText
                            id="auditEventSearch"
                            value={auditEventSearch}
                            onChange={(e) => setAuditEventSearch(e.target.value)}
                            placeholder="Search username, email, homeId, residentId, document name"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-12 md:col-4">
                          <label htmlFor="auditEventExcludeText" className="block mb-2" style={{ fontWeight: 600, color: "#0f172a" }}>Exclude Records Containing</label>
                          <InputText
                            id="auditEventExcludeText"
                            value={auditEventExcludeText}
                            onChange={(e) => setAuditEventExcludeText(e.target.value)}
                            placeholder="Comma-separated text to exclude"
                            style={{ width: "100%" }}
                          />
                        </div>
                      </div>
                      <div className="mt-3 flex justify-content-end">
                        <Button label="Search Audit Events" {...adminButtonProps} loading={auditEventsLoading} onClick={onLoadAuditEvents} />
                      </div>
                    </div>

                    {currentAuditEventsPage ? (
                      <div className="mb-4">
                        <div className="grid mb-3">
                          <div className="col-12 md:col-3">
                            {renderMetricCard("Window", activityLogRanges.find((item) => item.value === currentAuditEventsPage.range)?.label || currentAuditEventsPage.range, "accent")}
                          </div>
                          <div className="col-12 md:col-3">
                            {renderMetricCard("Events On Page", filteredCurrentAuditEvents.length || 0)}
                          </div>
                          <div className="col-12 md:col-3">
                            {renderMetricCard("Action Filter", currentAuditEventsPage.eventType || "All actions")}
                          </div>
                          <div className="col-12 md:col-3">
                            {renderMetricCard("Search Filter", currentAuditEventsPage.searchTerm || "All users")}
                          </div>
                          <div className="col-12 md:col-3">
                            {renderMetricCard("Excluded Text", auditEventExcludeText || "None")}
                          </div>
                        </div>
                        <div className="mb-4">
                          <div className="mb-3">
                            {renderSurfaceHeader("User Activity Timeline", "A visual sequence of what the selected user did on this audit-events page.", "pi pi-clock")}
                          </div>
                          {!String(auditEventSearch || "").trim() ? (
                            <div style={appNeutralPanelStyle}>
                              <div style={{ fontWeight: 700, color: "#0f172a" }}>Search for a specific user first</div>
                              <div className="mt-2" style={appMutedTextStyle}>
                                Enter a username, email, or userId in the audit-event search box to build a readable activity timeline for that person.
                              </div>
                            </div>
                          ) : currentAuditTimelineItems.length === 0 ? (
                            <div style={appNeutralPanelStyle}>
                              <div style={{ fontWeight: 700, color: "#0f172a" }}>No timeline items found</div>
                              <div className="mt-2" style={appMutedTextStyle}>
                                No events on this page matched the current user filter closely enough to build a timeline.
                              </div>
                            </div>
                          ) : (
                            <div
                              style={{
                                background: "#ffffff",
                                border: "1px solid #e2e8f0",
                                borderRadius: "18px",
                                padding: "1rem",
                              }}
                            >
                              <div className="mb-3" style={{ color: "#64748b", lineHeight: 1.7 }}>
                                Showing {currentAuditTimelineItems.length} timeline step{currentAuditTimelineItems.length === 1 ? "" : "s"} for{" "}
                                <strong style={{ color: "#0f172a" }}>{currentAuditTimelineItems[0]?.actor || auditEventSearch}</strong>.
                              </div>
                              <div style={{ display: "grid", gap: "0.85rem" }}>
                                {currentAuditTimelineItems.map((item: any, index: number) => {
                                  const toneStyles = getAuditTimelineToneStyles(item.tone);
                                  const previousDate = index > 0 && currentAuditTimelineItems[index - 1]?.timestamp
                                    ? new Date(currentAuditTimelineItems[index - 1].timestamp).toDateString()
                                    : null;
                                  const currentDate = item.timestamp ? new Date(item.timestamp).toDateString() : null;
                                  const shouldRenderDateDivider = !!currentDate && currentDate !== previousDate;

                                  return (
                                    <React.Fragment key={item.id}>
                                      {shouldRenderDateDivider ? (
                                        <div style={{ paddingTop: index === 0 ? 0 : "0.35rem" }}>
                                          <div
                                            style={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              padding: "0.3rem 0.7rem",
                                              borderRadius: "999px",
                                              background: "#eff6ff",
                                              color: "#1d4ed8",
                                              fontWeight: 700,
                                              fontSize: "0.85rem",
                                            }}
                                          >
                                            {new Date(item.timestamp).toLocaleDateString()}
                                          </div>
                                        </div>
                                      ) : null}
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: mobile ? "1fr" : "160px 1fr",
                                          gap: "0.9rem",
                                          alignItems: "start",
                                        }}
                                      >
                                        <div style={{ color: "#64748b", fontSize: "0.9rem", fontWeight: 600 }}>
                                          {item.timestamp ? new Date(item.timestamp).toLocaleTimeString() : "Unknown time"}
                                        </div>
                                        <div
                                          style={{
                                            position: "relative",
                                            background: toneStyles.bg,
                                            border: `1px solid ${toneStyles.border}`,
                                            borderRadius: "16px",
                                            padding: "0.95rem 1rem",
                                          }}
                                        >
                                          <div
                                            style={{
                                              position: "absolute",
                                              left: "-0.55rem",
                                              top: "1.15rem",
                                              width: "0.9rem",
                                              height: "0.9rem",
                                              borderRadius: "999px",
                                              background: toneStyles.dot,
                                              boxShadow: "0 0 0 4px #ffffff",
                                            }}
                                          />
                                          <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                                            <div style={{ color: "#0f172a", fontWeight: 700 }}>
                                              {item.actionLabel}
                                              {item.count > 1 ? ` (${item.count} times)` : ""}
                                            </div>
                                            <span
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                padding: "0.2rem 0.55rem",
                                                borderRadius: "999px",
                                                background: "#ffffff",
                                                color: toneStyles.text,
                                                fontWeight: 700,
                                                fontSize: "0.78rem",
                                                border: `1px solid ${toneStyles.border}`,
                                              }}
                                            >
                                              {item.status || "SUCCESS"}
                                            </span>
                                          </div>
                                          <div className="mt-2" style={{ color: "#334155", lineHeight: 1.7 }}>
                                            <strong>{normalizeTimelineLabel(item.actor)}</strong> {"->"} {normalizeTimelineLabel(item.resourceLabel)}
                                          </div>
                                          {item.message ? (
                                            <div className="mt-2" style={{ color: "#475569", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                                              {item.message}
                                            </div>
                                          ) : null}
                                          <div className="mt-3 flex flex-wrap gap-2" style={{ fontSize: "0.82rem", color: "#64748b" }}>
                                            <span><strong>Type:</strong> {item.eventType || "N/A"}</span>
                                            <span><strong>Service:</strong> {item.service || "N/A"}</span>
                                          </div>
                                          {item.metadata && Object.keys(item.metadata).length > 0 ? (
                                            <div className="mt-2" style={{ color: "#64748b", fontSize: "0.82rem", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                                              {JSON.stringify(item.metadata)}
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="mb-3 flex flex-wrap justify-content-between align-items-center gap-2">
                          <div style={appMutedTextStyle}>
                            Page {auditEventPageIndex + 1} • {currentAuditEventsPage.pageSize || AUDIT_EVENT_PAGE_SIZE} results per page
                          </div>
                          <div className="flex gap-2">
                            <Button
                              label="Previous"
                              {...adminButtonProps}
                              disabled={auditEventPageIndex === 0 || auditEventsLoading}
                              onClick={onPreviousAuditEventsPage}
                            />
                            <Button
                              label="Next"
                              {...adminButtonProps}
                              loading={auditEventsLoading}
                              disabled={!currentAuditEventsPage.nextToken}
                              onClick={onNextAuditEventsPage}
                            />
                          </div>
                        </div>
                        <div style={appDataTableWrapperStyle}>
                          <DataTable value={filteredCurrentAuditEvents || []} className="p-datatable-sm p-datatable-striped" emptyMessage="No audit events found for this range and filter.">
                            <Column field="timestamp" header="Time" body={(data) => data.timestamp ? new Date(data.timestamp).toLocaleString() : "N/A"} />
                            <Column field="eventType" header="Action" />
                            <Column header="User" body={(data) => getAuditUserColumnLabel(data)} />
                            <Column field="service" header="Service" />
                            <Column field="resourceName" header="Resource" body={(data) => data.resourceName || data.resourceId || data.homeId || data.residentId || "N/A"} />
                            <Column field="status" header="Status" />
                            <Column
                              field="message"
                              header="Details"
                              body={(data) => (
                                <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", maxWidth: "420px" }}>
                                  <div>{data.message || "N/A"}</div>
                                  {data.metadata && Object.keys(data.metadata).length > 0 ? (
                                    <div className="mt-2" style={{ color: "#64748b", fontSize: "0.85rem" }}>
                                      {JSON.stringify(data.metadata)}
                                    </div>
                                  ) : null}
                                </div>
                              )}
                            />
                          </DataTable>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {shouldShowAdminSection("activity") ? (
                  <div className="mb-4">
                    <div className="mb-3">
                      {renderSurfaceHeader("User Activity Logs", "Search recent CloudWatch logs across the main services by time window and optional user/email text.", "pi pi-history")}
                    </div>
                    <div style={{ ...appNeutralPanelStyle, marginBottom: "1rem" }}>
                      <div className="grid">
                        <div className="col-12 md:col-4">
                          <label htmlFor="activityLogRange" className="block mb-2" style={{ fontWeight: 600, color: "#0f172a" }}>Time Window</label>
                          <Dropdown
                            id="activityLogRange"
                            value={activityLogRange}
                            options={activityLogRanges}
                            onChange={(e) => setActivityLogRange(e.value)}
                            optionLabel="label"
                            optionValue="value"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-12 md:col-5">
                          <label htmlFor="activityLogSearch" className="block mb-2" style={{ fontWeight: 600, color: "#0f172a" }}>User / Email Filter</label>
                          <InputText
                            id="activityLogSearch"
                            value={activityLogSearch}
                            onChange={(e) => setActivityLogSearch(e.target.value)}
                            placeholder="Optional text like user name, email, residentId, jobId"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-12 md:col-3 flex align-items-end">
                          <Button label="Search Logs" {...adminButtonProps} loading={activityLogsLoading} onClick={onLoadActivityLogs} style={{ width: "100%" }} />
                        </div>
                      </div>
                      <div className="mt-3" style={appMutedTextStyle}>
                        Preset windows range from 1 hour to 1 month. The filter is optional and matches log message text.
                      </div>
                    </div>

                    {activityLogs ? (
                      <div>
                        <div className="grid mb-3">
                          <div className="col-12 md:col-3">
                            {renderMetricCard("Window", activityLogRanges.find((item) => item.value === activityLogs.range)?.label || activityLogs.range, "accent")}
                          </div>
                          <div className="col-12 md:col-3">
                            {renderMetricCard("Matched Events", activityLogs.items?.length || 0)}
                          </div>
                          <div className="col-12 md:col-3">
                            {renderMetricCard("Search Filter", activityLogs.searchTerm || "All activity")}
                          </div>
                          <div className="col-12 md:col-3">
                            {renderMetricCard("Generated", activityLogs.generatedAt ? new Date(activityLogs.generatedAt).toLocaleString() : "N/A")}
                          </div>
                        </div>
                        <div style={appDataTableWrapperStyle}>
                          <DataTable value={activityLogs.items || []} className="p-datatable-sm p-datatable-striped" emptyMessage="No activity found for this range and filter." rowClassName={renderActivityRow}>
                            <Column field="timestamp" header="Time" body={(data) => data.timestamp ? new Date(data.timestamp).toLocaleString() : "N/A"} />
                            <Column field="service" header="Service" body={(data) => data.service || data.logGroup || "Unknown"} />
                            <Column field="message" header="Activity" body={renderActivityMessage} />
                            <Column field="logStream" header="Log Stream" />
                          </DataTable>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {shouldShowAdminSection("users") && showAdminList ? (
                  <>
                    <div className="grid mb-3">
                      <div className="col-12 md:col-4">
                        {renderMetricCard("Active Subscriptions", totalSubscriptions.subscriptions.length || 0, "accent")}
                      </div>
                    </div>

                    {totalSubscriptions.subscriptions.length > 0 ? (
                      <div className="mb-4">
                        <div className="mb-3">
                          {renderSurfaceHeader("Subscriptions", "Select a user to inspect their active homes.", "pi pi-credit-card")}
                        </div>
                        <div style={appDataTableWrapperStyle}>
                          <DataTable
                            value={[...(totalSubscriptions.subscriptions || [])].sort((first: any, second: any) =>
                              new Date(second.createdAt || 0).getTime() - new Date(first.createdAt || 0).getTime(),
                            )}
                            className="p-datatable-sm p-datatable-striped"
                          >
                            <Column header="User" body={(data) =>
                              <a onClick={() => getAdminActiveUserDetails(data.userId)} style={{ cursor: "pointer", color: "#185DA2", fontWeight: 600 }}>
                                {data.userId}
                              </a>
                            } />
                            <Column field="allowedHomes" header="Homes" />
                            <Column field="allowedResidents" header="Residents" />
                          </DataTable>
                        </div>
                      </div>
                    ) : null}

                    <div>
                      <div className="mb-3">
                        {renderSurfaceHeader(
                          `User Directory (${adminUserList.length}${adminUserDirectoryTotal !== adminUserList.length ? ` of ${adminUserDirectoryTotal}` : ""})`,
                          "Open any record to review role and profile details.",
                          "pi pi-users",
                        )}
                      </div>
                      <div style={{ ...appNeutralPanelStyle, marginBottom: "1rem" }}>
                        <div className="grid align-items-end">
                          <div className="col-12 lg:col-6">
                            <label htmlFor="admin-user-exclude-prefixes" className="block mb-2" style={{ fontWeight: 600, color: "#334155" }}>
                              Exclude username or email starting with
                            </label>
                            <InputText
                              id="admin-user-exclude-prefixes"
                              value={adminUserExcludePrefixes}
                              onChange={(event) => setAdminUserExcludePrefixes(event.target.value)}
                              placeholder="ravishankar, testuser, demo"
                              className="w-full"
                              tooltip="Enter one or more comma-separated prefixes. Matching is case-insensitive."
                            />
                          </div>
                          <div className="col-12 sm:col-8 lg:col-4">
                            <label htmlFor="admin-user-role-filter" className="block mb-2" style={{ fontWeight: 600, color: "#334155" }}>
                              Role
                            </label>
                            <Dropdown
                              inputId="admin-user-role-filter"
                              value={adminUserRoleFilter}
                              options={[
                                { label: `All Roles (${adminUserDirectoryTotal})`, value: "" },
                                ...adminUserRoleCounts.map((roleCount) => ({
                                  label: `${getAdminRoleLabel(roleCount.roleType)} (${roleCount.count})`,
                                  value: roleCount.roleType,
                                })),
                              ]}
                              onChange={(event) => {
                                const nextRoleType = event.value || "";
                                setAdminUserRoleFilter(nextRoleType);
                                void ensureAdminUserDirectoryLoaded(true, { roleType: nextRoleType });
                              }}
                              disabled={adminUserListLoading}
                              className="w-full"
                            />
                          </div>
                          <div className="col-12 sm:col-4 lg:col-2">
                            <Button
                              type="button"
                              label="Apply"
                              icon="pi pi-filter"
                              className="w-full"
                              loading={adminUserListLoading}
                              onClick={() => void onApplyAdminUserDirectoryFilters()}
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap align-items-center gap-2 mt-3">
                          <Tag value={`All: ${adminUserDirectoryTotal}`} severity="info" rounded />
                          {adminUserRoleCounts.map((roleCount) => (
                            <Tag
                              key={roleCount.roleType}
                              value={`${getAdminRoleLabel(roleCount.roleType)}: ${roleCount.count}`}
                              rounded
                            />
                          ))}
                          {adminUserExcludedCount > 0 ? (
                            <Tag value={`Excluded: ${adminUserExcludedCount}`} severity="warning" rounded />
                          ) : null}
                        </div>
                      </div>
                      <div style={appDataTableWrapperStyle}>
                        <DataTable
                          value={adminUserList}
                          className="p-datatable-sm p-datatable-striped"
                          loading={adminUserListLoading}
                          emptyMessage="No users match the selected directory filters."
                        >
                          <Column field="Username" header="Username" body={(data) =>
                            <a onClick={() => getAdminUserProfileDetails(data)} style={{ cursor: "pointer", color: "#185DA2", fontWeight: 600 }}>
                              {data.Username}
                            </a>
                          } />
                          <Column field="Attributes" header="Email" body={(data) => data.Attributes.find((attr: any) => attr.Name === "email")?.Value} />
                          <Column field="Attributes" header="Phone" body={(data) => getCognitoUserAttribute(data, "custom:phone_number") || getCognitoUserAttribute(data, "phone_number") || "N/A"} />
                          <Column
                            field="Attributes"
                            header="Role"
                            body={(data) => getAdminRoleLabel(data.Attributes.find((attr: any) => attr.Name === "custom:custom_role_type")?.Value || "unassigned")}
                          />
                          <Column field="Enabled" header="Status" body={(data) => data.Enabled ? "Enabled" : "Disabled"} />
                          <Column field="isSubscribed" header="Subscribed" body={(data) => data.isSubscribed ? "Yes" : "No"} />
                          <Column field="UserCreateDate" header="Joined" body={(data) => new Date(data.UserCreateDate).toLocaleDateString()} />
                        </DataTable>
                      </div>
                    </div>
                  </>
                ) : null}

                {shouldShowAdminSection("feedback") && showCustomerFeedbacks && customerFeedbacks.length > 0 ? (
                  <div>
                    <div className="mb-3">
                      {renderSurfaceHeader(`Customer Feedback (${customerFeedbacks.length})`, "Recent product suggestions, bug reports, and general notes.", "pi pi-comments")}
                    </div>
                    <div style={appDataTableWrapperStyle}>
                      <DataTable
                        value={[...customerFeedbacks].sort((first: any, second: any) =>
                          new Date(second.createdAt || 0).getTime() - new Date(first.createdAt || 0).getTime(),
                        )}
                        className="p-datatable-sm p-datatable-striped"
                        sortField="createdAt"
                        sortOrder={-1}
                        emptyMessage="No customer feedback found."
                      >
                        <Column field="createdAt" header="Submitted" body={(data) => data.createdAt ? new Date(data.createdAt).toLocaleString("en-US", { timeZone: "America/Los_Angeles" }) : "N/A"} />
                        <Column field="createdBy" header="Submitted By" body={(data) => data.createdBy || "Unknown"} />
                        <Column field="status" header="Status" body={(data) => <Tag value={String(data?.status || "NEW").replace(/_/g, " ")} severity={data?.status === "WAITING_FOR_USER" ? "success" : "warning"} rounded />} />
                        <Column field="title" header="Title" body={(data) => data.title || "Untitled"} />
                        <Column field="feedbackType" header="Category" body={(data) => data.feedbackType?.name || (typeof data.feedbackType === "string" ? data.feedbackType : "General")} />
                        <Column
                          field="feedbackComment"
                          header="Feedback"
                          body={(data) => (
                            <div style={{ whiteSpace: "pre-wrap", minWidth: "18rem", maxWidth: "42rem" }}>
                              {data.feedbackComment || "N/A"}
                            </div>
                          )}
                        />
                        <Column header="Action" body={(data) => <Button type="button" label="View / Reply" icon="pi pi-comments" size="small" rounded outlined onClick={() => void openAdminCustomerFeedback(data)} />} />
                      </DataTable>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </AccordionTab>
          {shouldShowAdminSection("binder") ? (
            <AccordionTab
              headerTemplate={() => renderSurfaceHeader(
                "Binder Rules",
                "Manage versioned binder compliance rules and effective dates.",
                "pi pi-book",
              )}
            >
              <div style={dashboardSectionCardStyle}>
                <div style={{ ...appAccentPanelStyle, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
                  <div className="flex flex-wrap justify-content-between align-items-center gap-3">
                    <div>
                      <div style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}>Rule Registry</div>
                      <div className="mt-2" style={appMutedTextStyle}>
                        Active binder checks now come from these versioned rules instead of hardcoded folder logic alone.
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      <Dropdown
                        value={selectedBinderRuleType}
                        options={[
                          { label: "Resident Binder", value: BinderType.RESIDENT },
                          { label: "Home Binder", value: BinderType.HOME },
                        ]}
                        onChange={(e) => setSelectedBinderRuleType(e.value)}
                        optionLabel="label"
                        optionValue="value"
                      />
                      <Button label="Refresh Rules" {...adminButtonProps} loading={binderRulesLoading} onClick={() => void loadBinderRules(selectedBinderRuleType)} />
                      <Button label="Add Rule" {...adminButtonProps} onClick={openCreateBinderRuleDialog} />
                    </div>
                  </div>
                </div>
                <div style={{ padding: "1.25rem" }}>
                  <div className="grid mb-3">
                    <div className="col-12 md:col-3">
                      {renderMetricCard("Total Versions", binderRules.length, "accent")}
                    </div>
                    <div className="col-12 md:col-3">
                      {renderMetricCard("Active Rules", binderRules.filter((rule) => String(rule.status || "active").toLowerCase() === "active").length)}
                    </div>
                    <div className="col-12 md:col-3">
                      {renderMetricCard("Retired Versions", binderRules.filter((rule) => String(rule.status || "").toLowerCase() === "retired").length)}
                    </div>
                    <div className="col-12 md:col-3">
                      {renderMetricCard("Folders Covered", new Set(binderRules.map((rule) => rule.folderCode)).size)}
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
                      <div>
                        {renderSurfaceHeader("Monitored Sources", "Official WAC and DSHS pages checked for changes.", "pi pi-globe")}
                      </div>
                      <div className="flex flex-wrap gap-2">
                        <Button label="Run Monitor" {...adminButtonProps} loading={runningBinderRuleMonitor} onClick={() => void onRunBinderRuleMonitor()} />
                        <Button label="Add Source" {...adminButtonProps} onClick={openCreateBinderRuleSourceDialog} />
                      </div>
                    </div>
                    <div style={appDataTableWrapperStyle}>
                      <DataTable value={binderRuleSources} className="p-datatable-sm p-datatable-striped" loading={binderRuleSourcesLoading} emptyMessage="No binder rule sources found yet.">
                        <Column field="title" header="Source" />
                        <Column field="citation" header="Citation" body={(data) => data.citation || "Not set"} />
                        <Column field="sourceType" header="Type" />
                        <Column field="snapshotCount" header="Snapshots" body={(data) => data.snapshotCount || 0} />
                        <Column field="lastSeenEffectiveDate" header="Latest Effective Date" body={(data) => data.lastSeenEffectiveDate || "Not detected"} />
                        <Column field="lastCheckedAt" header="Last Checked" body={(data) => data.lastCheckedAt ? new Date(data.lastCheckedAt).toLocaleString() : "Never"} />
                        <Column header="Status" body={renderBinderRuleSourceStatus} />
                        <Column header="Actions" body={renderBinderRuleSourceActions} />
                      </DataTable>
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="mb-3">
                      {renderSurfaceHeader("Change Alerts", "Review detected source changes before publishing new binder rule versions.", "pi pi-bell")}
                    </div>
                    <div style={appDataTableWrapperStyle}>
                      <DataTable value={binderRuleAlerts} className="p-datatable-sm p-datatable-striped" loading={binderRuleAlertsLoading} emptyMessage="No binder rule change alerts detected yet.">
                        <Column field="title" header="Source" />
                        <Column field="citation" header="Citation" body={(data) => data.citation || "Not set"} />
                        <Column field="createdAt" header="Detected" body={(data) => data.createdAt ? new Date(data.createdAt).toLocaleString() : "N/A"} />
                        <Column header="Status" body={renderBinderRuleAlertStatus} />
                        <Column field="summarySource" header="Summary Type" body={(data) => data.summarySource || "deterministic"} />
                        <Column field="changeSummary" header="Generated Summary" />
                        <Column header="Actions" body={renderBinderRuleAlertActions} />
                      </DataTable>
                    </div>
                  </div>
                  <div style={appDataTableWrapperStyle}>
                    <DataTable value={binderRules} className="p-datatable-sm p-datatable-striped" loading={binderRulesLoading} emptyMessage="No binder rules found yet.">
                      <Column field="folderCode" header="Folder Code" />
                      <Column field="title" header="Rule Title" />
                      <Column field="versionNumber" header="Version" />
                      <Column header="Status" body={renderBinderRuleStatus} />
                      <Column field="effectiveFrom" header="Effective From" />
                      <Column field="effectiveTo" header="Effective To" body={(data) => data.effectiveTo || "Open"} />
                      <Column field="expectedDocumentCount" header="Expected Docs" />
                      <Column field="citation" header="Citation" body={(data) => data.citation || "Not set"} />
                      <Column header="Actions" body={renderBinderRuleActions} />
                    </DataTable>
                  </div>
                </div>
              </div>
            </AccordionTab>
          ) : null}
        </Accordion>
      </div>

      <Dialog
        header={renderSurfaceHeader(
          selectedProviderDirectoryChange?.facilityName ? `${selectedProviderDirectoryChange.facilityName} Change Details` : "Provider Change Details",
          "Review the tracked field differences for this provider directory change record.",
          "pi pi-list-check",
        )}
        visible={showProviderDirectoryChangeDialog}
        modal
        onHide={() => {
          setShowProviderDirectoryChangeDialog(false);
          setSelectedProviderDirectoryChange(null);
        }}
        style={appDialogStyle}
        headerStyle={appDialogHeaderStyle}
        contentStyle={appDialogContentStyle}
      >
        <div className="flex flex-column gap-3">
          <div style={appNeutralPanelStyle}>
            <div className="grid" style={appMutedTextStyle}>
              <div className="col-12 md:col-6"><strong>Facility:</strong> {selectedProviderDirectoryChange?.facilityName || "Unknown"}</div>
              <div className="col-12 md:col-6"><strong>License #:</strong> {selectedProviderDirectoryChange?.licenseNumber || "N/A"}</div>
              <div className="col-12 md:col-6"><strong>County:</strong> {selectedProviderDirectoryChange?.locationCounty || "N/A"}</div>
              <div className="col-12 md:col-6"><strong>Change Type:</strong> {selectedProviderDirectoryChange?.changeType || "N/A"}</div>
            </div>
          </div>
          <div style={appDataTableWrapperStyle}>
            <DataTable
              value={selectedProviderDirectoryChange?.fieldDiffs || []}
              className="p-datatable-sm p-datatable-striped"
              emptyMessage="No tracked field differences were stored for this change."
              paginator
              rows={10}
            >
              <Column field="field" header="Field" />
              <Column field="previousValue" header="Previous Value" body={(data: any) => data.previousValue || "Blank"} />
              <Column field="currentValue" header="Current Value" body={(data: any) => data.currentValue || "Blank"} />
            </DataTable>
          </div>
        </div>
      </Dialog>

      <Dialog
        header={renderSurfaceHeader(
          "Email Users",
          "Send a branded platform update to specific email addresses or all active Cognito users.",
          "pi pi-envelope",
        )}
        visible={showEmailCampaignDialog}
        modal
        onHide={() => !sendingEmailCampaign && setShowEmailCampaignDialog(false)}
        style={appWideDialogStyle}
        headerStyle={appDialogHeaderStyle}
        contentStyle={appDialogContentStyle}
        footer={renderDialogFooter({
          errorMessage: emailCampaignError,
          loading: sendingEmailCampaign,
          onCancel: () => setShowEmailCampaignDialog(false),
          onSubmit: onSendEmailCampaign,
          submitLabel: "Send Email",
        })}
      >
        <div className="grid">
          <div className="col-12 md:col-4">
            <div style={appNeutralPanelStyle}>
              <label className="block mb-2" style={{ fontWeight: 700 }}>Template</label>
              <Dropdown
                value={emailCampaignTemplateType}
                options={Object.entries(EMAIL_CAMPAIGN_TEMPLATES).map(([value, template]) => ({
                  label: template.label,
                  value,
                }))}
                onChange={(e) => applyEmailCampaignTemplate(e.value)}
                optionLabel="label"
                optionValue="value"
                className="w-full"
              />

              <label className="block mt-4 mb-2" style={{ fontWeight: 700 }}>To</label>
              <AutoComplete
                value={emailCampaignUserLookup}
                suggestions={emailCampaignUserSuggestions}
                completeMethod={completeEmailCampaignUserSearch}
                field="displayLabel"
                dropdown
                forceSelection
                className="w-full"
                placeholder="Search Cognito users by email, username, or role"
                onChange={(e) => setEmailCampaignUserLookup(e.value)}
                onSelect={(e) => {
                  const selectedUser = e.value;
                  setEmailCampaignSelectedUser(selectedUser || null);
                  appendEmailCampaignRecipient(getCognitoUserAttribute(selectedUser, "email"));
                  setEmailCampaignUserLookup(null);
                }}
              />
              <div className="mt-2" style={appMutedTextStyle}>
                Search a Cognito user to add their email automatically, or type any email address manually below.
              </div>

              {emailCampaignSelectedUser ? (
                <div
                  className="mt-3"
                  style={{
                    border: "1px solid #fdba74",
                    background: "linear-gradient(180deg, #fff7ed 0%, #ffffff 100%)",
                    borderRadius: "16px",
                    padding: "1rem",
                    boxShadow: "0 10px 24px rgba(249, 115, 22, 0.08)",
                  }}
                >
                  <div className="flex justify-content-between align-items-start gap-2 flex-wrap">
                    <div>
                      <div style={{ fontWeight: 800, color: "#9a3412", letterSpacing: "0.01em" }}>Selected Cognito User</div>
                      <div className="mt-1" style={{ ...appMutedTextStyle, color: "#7c2d12" }}>
                        Review the account details before sending to this recipient.
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      <Tag value={getCognitoUserAttribute(emailCampaignSelectedUser, "custom:custom_role_type") || "No role"} severity="warning" />
                      <Tag value={emailCampaignSelectedUser?.Enabled ? "Enabled" : "Disabled"} severity={emailCampaignSelectedUser?.Enabled ? "success" : "danger"} />
                      <Tag value={emailCampaignSelectedUser?.isSubscribed ? "Subscribed" : "Not subscribed"} severity={emailCampaignSelectedUser?.isSubscribed ? "info" : "secondary"} />
                    </div>
                  </div>

                  <div className="grid mt-2">
                    <div className="col-12 md:col-6">
                      <div style={{ border: "1px solid #fed7aa", borderRadius: "12px", background: "#ffffff", padding: "0.75rem" }}>
                        <div style={{ fontSize: "0.78rem", fontWeight: 700, color: "#9a3412", textTransform: "uppercase", letterSpacing: "0.04em" }}>Username</div>
                        <div style={{ ...appMutedTextStyle, marginTop: "0.35rem", color: "#0f172a", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                          {emailCampaignSelectedUser?.Username || "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div style={{ border: "1px solid #fed7aa", borderRadius: "12px", background: "#ffffff", padding: "0.75rem" }}>
                        <div style={{ fontSize: "0.78rem", fontWeight: 700, color: "#9a3412", textTransform: "uppercase", letterSpacing: "0.04em" }}>Email</div>
                        <div style={{ ...appMutedTextStyle, marginTop: "0.35rem", color: "#0f172a", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                          {getCognitoUserAttribute(emailCampaignSelectedUser, "email") || "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div style={{ border: "1px solid #fed7aa", borderRadius: "12px", background: "#ffffff", padding: "0.75rem" }}>
                        <div style={{ fontSize: "0.78rem", fontWeight: 700, color: "#9a3412", textTransform: "uppercase", letterSpacing: "0.04em" }}>Created</div>
                        <div style={{ ...appMutedTextStyle, marginTop: "0.35rem", color: "#0f172a", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                          {emailCampaignSelectedUser?.UserCreateDate ? new Date(emailCampaignSelectedUser.UserCreateDate).toLocaleString() : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div style={{ border: "1px solid #fed7aa", borderRadius: "12px", background: "#ffffff", padding: "0.75rem" }}>
                        <div style={{ fontSize: "0.78rem", fontWeight: 700, color: "#9a3412", textTransform: "uppercase", letterSpacing: "0.04em" }}>User Status</div>
                        <div style={{ ...appMutedTextStyle, marginTop: "0.35rem", color: "#0f172a", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                          {emailCampaignSelectedUser?.Enabled ? "Enabled account" : "Disabled account"}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-3" style={{ fontWeight: 700, color: "#9a3412" }}>Cognito attributes</div>
                  <div
                    className="mt-2"
                    style={{
                      maxHeight: "12rem",
                      overflow: "auto",
                      border: "1px solid #fed7aa",
                      borderRadius: "12px",
                      background: "#ffffff",
                      padding: "0.75rem",
                    }}
                  >
                    {(emailCampaignSelectedUser?.Attributes || []).map((attribute: any) => (
                      <div
                        key={`${attribute?.Name}-${attribute?.Value}`}
                        className="mb-2"
                        style={{
                          ...appMutedTextStyle,
                          color: "#334155",
                          paddingBottom: "0.5rem",
                          borderBottom: "1px solid #ffedd5",
                          wordBreak: "break-word",
                          overflowWrap: "anywhere",
                        }}
                      >
                        <strong style={{ color: "#9a3412" }}>{attribute?.Name}:</strong> {attribute?.Value || "Blank"}
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}

              <InputTextarea
                value={emailCampaignManualTo}
                onChange={(e) => setEmailCampaignManualTo(e.target.value)}
                rows={7}
                className="w-full"
                placeholder="Add one email per line, or separate emails with commas."
              />
              <div className="mt-2" style={appMutedTextStyle}>
                Add any email manually here. {getManualCampaignEmails().length} recipient{getManualCampaignEmails().length === 1 ? "" : "s"} currently included.
              </div>

              <div className="mt-4 flex align-items-center gap-2">
                <Checkbox
                  inputId="emailCampaignSendAll"
                  checked={emailCampaignSendToAll}
                  onChange={(e) => setEmailCampaignSendToAll(!!e.checked)}
                />
                <label htmlFor="emailCampaignSendAll" style={{ fontWeight: 600, margin: 0 }}>
                  Send to all active Cognito users
                </label>
              </div>

              {emailCampaignSendToAll ? (
                <div className="mt-4">
                  <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: "0.6rem" }}>Active user roles</div>
                  <div className="flex flex-column gap-2">
                    {emailCampaignRoleOptions.map((option) => {
                      const checked = emailCampaignRoleFilters.includes(option.value);
                      return (
                        <div className="flex align-items-center gap-2" key={option.value}>
                          <Checkbox
                            inputId={`emailCampaignRole-${option.value}`}
                            checked={checked}
                            onChange={(e) => {
                              setEmailCampaignRoleFilters((prev) => {
                                if (e.checked) {
                                  return prev.includes(option.value) ? prev : [...prev, option.value];
                                }
                                return prev.filter((value) => value !== option.value);
                              });
                            }}
                          />
                          <label htmlFor={`emailCampaignRole-${option.value}`} style={{ fontWeight: 600 }}>
                            {option.label}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                  <div className="mt-2" style={appMutedTextStyle}>
                    Leave all unchecked to include every active user role.
                  </div>
                </div>
              ) : null}

              <div className="mt-4" style={appAccentPanelStyle}>
                <div style={{ fontWeight: 700, color: "#9a3412" }}>Send behavior</div>
                <div className="mt-2" style={appMutedTextStyle}>
                  Manual recipients and active users are merged and deduplicated. Each recipient receives a personalized email and is processed individually to avoid SES throttling.
                </div>
                <div className="mt-3">
                  <Button label="Preview Audience" {...adminButtonProps} loading={emailCampaignPreviewLoading} onClick={() => void loadEmailCampaignPreview()} />
                </div>
              </div>

              {emailCampaignPreview ? (
                <div className="mt-4" style={appNeutralPanelStyle}>
                  <div style={{ fontWeight: 700, color: "#0f172a" }}>Audience preview</div>
                  <div className="mt-2" style={appMutedTextStyle}>
                    {emailCampaignPreview.totalRecipients || 0} total recipients, including {emailCampaignPreview.manualRecipientCount || 0} manual and {emailCampaignPreview.activeRecipientCount || 0} active-user recipients.
                  </div>
                  <div className="mt-2" style={appMutedTextStyle}>
                    Delivery begins one recipient at a time after you send the campaign.
                  </div>
                  {emailCampaignPreview.sampleRecipients?.length ? (
                    <div className="mt-3 flex flex-wrap gap-2">
                      {emailCampaignPreview.sampleRecipients.slice(0, 8).map((recipient: string) => (
                        <Tag key={recipient} value={recipient} severity="info" />
                      ))}
                    </div>
                  ) : null}
                </div>
              ) : null}

              {emailCampaignResult?.campaignId ? (
                <div className="mt-4" style={appNeutralPanelStyle}>
                  <div className="flex justify-content-between align-items-center gap-2 flex-wrap">
                    <div>
                      <div style={{ fontWeight: 700, color: "#0f172a" }}>Recipient delivery status</div>
                      <div className="mt-1" style={appMutedTextStyle}>
                        {emailCampaignResult.totalRecipients || 0} queued · {emailCampaignDeliveries.filter((item) => item.status === "sent").length} sent · {emailCampaignDeliveries.filter((item) => item.status === "failed").length} failed
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <Button label="Refresh" icon="pi pi-refresh" {...adminButtonProps} size="small" loading={emailCampaignDeliveriesLoading} onClick={() => void loadEmailCampaignDeliveries(emailCampaignResult.campaignId)} />
                      <Button label="Queue not-sent again" icon="pi pi-send" {...adminButtonProps} size="small" loading={requeueingUnattemptedCampaign} disabled={!emailCampaignDeliveries.some((item) => Number(item.attemptCount || 0) === 0 && !["sent", "skipped"].includes(String(item.status || "")))} onClick={() => void requeueUnattemptedCampaignDeliveries()} />
                      <Button label="Export failures" icon="pi pi-file-excel" {...adminButtonProps} size="small" disabled={!emailCampaignDeliveries.some((item) => item.status === "failed")} onClick={() => emailCampaignFailureTableRef.current?.exportCSV()} />
                    </div>
                  </div>
                  {emailCampaignDeliveries.some((item) => Number(item.attemptCount || 0) === 0 && !["sent", "skipped"].includes(String(item.status || ""))) ? (
                    <div className="mt-3">
                      <div style={{ fontWeight: 700, color: "#0f172a" }}>Not sent yet (0 attempts)</div>
                      <div className="mt-1" style={appMutedTextStyle}>These recipients have not reached the email worker. Use the button above to queue them again.</div>
                      <div className="mt-2 flex flex-wrap gap-2">
                        {emailCampaignDeliveries
                          .filter((item) => Number(item.attemptCount || 0) === 0 && !["sent", "skipped"].includes(String(item.status || "")))
                          .map((item) => <Tag key={item.recordKey} value={item.recipientEmail || "Unknown recipient"} severity="warning" />)}
                      </div>
                    </div>
                  ) : null}
                  <div className="mt-3" style={appDataTableWrapperStyle}>
                    <DataTable value={emailCampaignDeliveries} size="small" scrollable scrollHeight="16rem" emptyMessage={emailCampaignDeliveriesLoading ? "Loading recipients..." : "Recipients are being queued."}>
                      <Column field="recipientEmail" header="Recipient" />
                      <Column field="recipientFirstName" header="First name" />
                      <Column field="status" header="Status" body={(item: any) => <Tag value={item.status || "queued"} severity={item.status === "sent" ? "success" : item.status === "failed" ? "danger" : item.status === "sending" ? "info" : "warning"} />} />
                      <Column field="attemptCount" header="Attempts" />
                      <Column field="failureReason" header="Failure" />
                    </DataTable>
                  </div>
                  <DataTable ref={emailCampaignFailureTableRef} value={emailCampaignDeliveries.filter((item) => item.status === "failed")} style={{ display: "none" }}>
                    <Column field="recipientEmail" header="Recipient" />
                    <Column field="recipientFirstName" header="First name" />
                    <Column field="status" header="Status" />
                    <Column field="attemptCount" header="Attempts" />
                    <Column field="failureReason" header="Failure reason" />
                  </DataTable>
                </div>
              ) : null}

              <div className="mt-4" style={appNeutralPanelStyle}>
                <div className="flex justify-content-between align-items-center gap-2">
                  <div style={{ fontWeight: 700, color: "#0f172a" }}>Campaigns</div>
                  <Button label="Refresh" {...adminButtonProps} size="small" loading={emailCampaignHistoryLoading} onClick={() => void loadEmailCampaignHistory()} />
                </div>
                <div className="mt-3">
                  {emailCampaignHistory.length === 0 ? (
                    <div style={appMutedTextStyle}>
                      {emailCampaignHistoryLoading ? "Loading campaigns..." : "No campaigns sent yet."}
                    </div>
                  ) : (
                    <div style={{ maxHeight: "14rem", overflow: "auto" }}>
                      {emailCampaignHistory.map((item: any) => (
                        <div key={item.campaignId} className="mb-3" style={{ borderBottom: "1px solid #e2e8f0", paddingBottom: "0.75rem" }}>
                          <div style={{ fontWeight: 600, color: "#0f172a" }}>{item.subject || "Admin email campaign"}</div>
                          <div className="mt-1" style={appMutedTextStyle}>
                            {item.createdAt ? new Intl.DateTimeFormat("en-US", { timeZone: "America/Los_Angeles", dateStyle: "medium", timeStyle: "short" }).format(new Date(item.createdAt)) : "Unknown time"} · {item.totalRecipients || 0} recipients · {item.sentCount || 0} sent · {item.failedCount || 0} failed · {item.pendingCount || 0} pending
                          </div>
                          <div className="mt-2">
                            <Tag value={String(item.status || "queued").replaceAll("_", " ")} severity={item.status === "completed" ? "success" : item.status === "completed_with_failures" ? "danger" : "warning"} />
                          </div>
                          <div style={{ display: "none" }}>
                            {item.timestamp ? new Date(item.timestamp).toLocaleString() : "Unknown time"} · {(item.metadata?.successCount || 0)} sent · {(item.metadata?.failureCount || 0)} failed
                          </div>
                          <div className="mt-2 flex flex-wrap gap-2">
                            {Number(item.failedCount || 0) > 0 ? (
                              <Button
                                label="Retry Failed"
                                {...adminButtonProps}
                                size="small"
                                loading={retryingCampaignId === String(item.campaignId || "")}
                                onClick={() => void retryFailedCampaignRecipients(item)}
                              />
                            ) : null}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 md:col-8">
            <div style={appNeutralPanelStyle}>
              <label className="block mb-2" style={{ fontWeight: 700 }}>Subject</label>
              <InputText
                value={emailCampaignSubject}
                onChange={(e) => setEmailCampaignSubject(e.target.value)}
                className="w-full"
                placeholder="Add email subject"
              />

              <label className="block mt-4 mb-2" style={{ fontWeight: 700 }}>Email Body</label>
              <div className="flex flex-wrap gap-2 mb-2">
                <Button type="button" label="Bold" {...adminButtonProps} size="small" onClick={() => runEmailEditorCommand("bold")} />
                <Button type="button" label="Italic" {...adminButtonProps} size="small" onClick={() => runEmailEditorCommand("italic")} />
                <Button type="button" label="Bullet List" {...adminButtonProps} size="small" onClick={() => runEmailEditorCommand("insertUnorderedList")} />
                <Button type="button" label="Numbered List" {...adminButtonProps} size="small" onClick={() => runEmailEditorCommand("insertOrderedList")} />
                <Button
                  type="button"
                  label="Link"
                  {...adminButtonProps}
                  size="small"
                  onClick={() => {
                    const url = window.prompt("Enter a full URL");
                    if (url) {
                      runEmailEditorCommand("createLink", url);
                    }
                  }}
                />
              </div>
              <div
                ref={emailCampaignEditorRef}
                contentEditable
                suppressContentEditableWarning
                onInput={(e) => setEmailCampaignHtmlBody((e.currentTarget as HTMLDivElement).innerHTML)}
                style={{
                  minHeight: "18rem",
                  background: "#ffffff",
                  border: "1px solid #d9e2ec",
                  borderRadius: "12px",
                  padding: "1rem",
                  lineHeight: 1.7,
                  color: "#17324d",
                  overflow: "auto",
                }}
              />
            </div>

            <div className="mt-4" style={appNeutralPanelStyle}>
              <div className="flex justify-content-between align-items-center gap-2">
                <div style={{ fontWeight: 700, color: "#0f172a" }}>Preview</div>
                <Tag value={EMAIL_CAMPAIGN_TEMPLATES[emailCampaignTemplateType].label} severity="warning" />
              </div>
              <div className="mt-3" style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "16px", padding: "1rem" }}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: sanitizeRichHtml(`
                      ${emailCampaignHtmlBody || "<p>Your email content will appear here.</p>"}
                    `),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        header={renderSurfaceHeader(
          demoSlotForm?.slotId ? "Edit Demo Slot" : "New Demo Slot",
          "Create or update public demo availability for any past or future date in America/Los_Angeles.",
          "pi pi-calendar-plus",
        )}
        visible={showDemoSlotDialog}
        modal
        onHide={() => !savingDemoSlot && setShowDemoSlotDialog(false)}
        style={{ ...appWideDialogStyle, width: "min(92vw, 68rem)" }}
        headerStyle={appDialogHeaderStyle}
        contentStyle={appDialogContentStyle}
        footer={renderDialogFooter({
          loading: savingDemoSlot,
          onCancel: () => setShowDemoSlotDialog(false),
          onSubmit: () => void saveDemoSlot(),
          submitLabel: demoSlotForm?.slotId ? "Save Slot" : "Create Slot",
        })}
      >
        <div className="grid">
          <div className="col-12 lg:col-5">
            <div style={{ ...appNeutralPanelStyle, margin: 0, height: "100%" }}>
              <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: "0.9rem" }}>Schedule</div>
              <div className="flex flex-column gap-3">
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>Date</label>
                  <Calendar
                    value={parseCalendarDateKey(demoSlotForm.slotDate || "")}
                    onChange={(e) => setDemoSlotForm((current: any) => ({ ...current, slotDate: formatCalendarDateKey((e.value as Date) || null) }))}
                    dateFormat="mm/dd/yy"
                    showIcon
                    className="w-full"
                    placeholder="Choose a date"
                  />
                </div>
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>Start time</label>
                  <Dropdown
                    value={demoSlotForm.startTime || ""}
                    options={demoTimeOptions}
                    onChange={(e) => setDemoSlotForm((current: any) => ({ ...current, startTime: e.value || "" }))}
                    className="w-full"
                    placeholder="Select start time"
                  />
                </div>
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>End time</label>
                  <Dropdown
                    value={demoSlotForm.endTime || ""}
                    options={demoTimeOptions}
                    onChange={(e) => setDemoSlotForm((current: any) => ({ ...current, endTime: e.value || "" }))}
                    className="w-full"
                    placeholder="Select end time"
                  />
                </div>
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>Capacity</label>
                  <InputText
                    value={String(demoSlotForm.capacity || 0)}
                    onChange={(e) => setDemoSlotForm((current: any) => ({ ...current, capacity: Number(e.target.value || 0) }))}
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>Status</label>
                  <Dropdown
                    value={demoSlotForm.status || "open"}
                    options={[
                      { label: "Open", value: "open" },
                      { label: "Closed", value: "closed" },
                      { label: "Cancelled", value: "cancelled" },
                    ]}
                    onChange={(e) => setDemoSlotForm((current: any) => ({ ...current, status: e.value }))}
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>Timezone</label>
                  <InputText value="America/Los_Angeles" disabled className="w-full" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 lg:col-7">
            <div style={{ ...appNeutralPanelStyle, margin: 0 }}>
              <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: "0.9rem" }}>Session details</div>
              <div className="flex flex-column gap-3">
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>Demo title</label>
                  <InputText
                    value={demoSlotForm.demoTitle || ""}
                    onChange={(e) => setDemoSlotForm((current: any) => ({ ...current, demoTitle: e.target.value }))}
                    className="w-full"
                    placeholder="General Product Demo"
                  />
                </div>
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>Feature list</label>
                  <MultiSelect
                    value={demoSlotForm.selectedFeatures || []}
                    options={(demoFeatureOptions || []).map((item) => ({ label: item, value: item }))}
                    onChange={(e) => {
                      const nextSelectedFeatures = e.value || [];
                      setDemoSlotForm((current: any) => ({ ...current, selectedFeatures: nextSelectedFeatures }));
                      if (!demoFeatureNotesTouched || !String(demoSlotForm.customFeatureNotes || "").trim()) {
                        void generateDemoFeatureNotesForSelection(nextSelectedFeatures, String(demoSlotForm.demoTitle || ""));
                      }
                    }}
                    placeholder="Select demo features"
                    maxSelectedLabels={3}
                    display="chip"
                    className="w-full"
                  />
                </div>
                <div>
                  <div className="flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                    <label className="m-0" style={{ fontWeight: 600 }}>Custom feature notes</label>
                    <Button
                      label={generatingDemoFeatureNotes ? "Generating..." : "Generate With AI"}
                      icon="pi pi-sparkles"
                      severity="warning"
                      outlined
                      rounded
                      size="small"
                      loading={generatingDemoFeatureNotes}
                      disabled={(demoSlotForm.selectedFeatures || []).length === 0}
                      onClick={() => void generateDemoFeatureNotesForSelection()}
                    />
                  </div>
                  <InputTextarea
                    rows={5}
                    value={demoSlotForm.customFeatureNotes || ""}
                    onChange={(e) => {
                      setDemoFeatureNotesTouched(true);
                      setDemoSlotForm((current: any) => ({ ...current, customFeatureNotes: e.target.value }));
                    }}
                    className="w-full"
                    placeholder="AI-generated notes will appear here based on the selected demo features."
                    autoResize
                  />
                </div>
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>Meeting link</label>
                  <InputText
                    value={demoSlotForm.meetingLink || ""}
                    onChange={(e) => setDemoSlotForm((current: any) => ({ ...current, meetingLink: e.target.value }))}
                    className="w-full"
                    placeholder="https://meet.google.com/... or https://zoom.us/..."
                  />
                </div>
                <div>
                  <label className="block mb-2" style={{ fontWeight: 600 }}>Internal notes</label>
                  <InputTextarea
                    rows={3}
                    value={demoSlotForm.notes || ""}
                    onChange={(e) => setDemoSlotForm((current: any) => ({ ...current, notes: e.target.value }))}
                    className="w-full"
                    autoResize
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        header={renderSurfaceHeader(
          selectedDemoSlot?.demoTitle ? `${selectedDemoSlot.demoTitle} Signups` : "Demo Signups",
          "Review booked and cancelled attendees for this specific public demo slot.",
          "pi pi-users",
        )}
        visible={showDemoRegistrationsDialog}
        modal
        onHide={() => setShowDemoRegistrationsDialog(false)}
        style={appWideDialogStyle}
        headerStyle={appDialogHeaderStyle}
        contentStyle={appDialogContentStyle}
      >
        <div className="grid mb-3">
          <div className="col-12 md:col-3">{renderMetricCard("Booked", Number(selectedDemoSlot?.bookedCount || 0), "accent")}</div>
          <div className="col-12 md:col-3">{renderMetricCard("Cancelled", Number(selectedDemoSlot?.cancelledCount || 0))}</div>
          <div className="col-12 md:col-3">{renderMetricCard("Capacity", Number(selectedDemoSlot?.capacity || 0))}</div>
          <div className="col-12 md:col-3">{renderMetricCard("Seats Left", Number(selectedDemoSlot?.seatsRemaining || 0))}</div>
        </div>
        {String(selectedDemoSlot?.meetingLink || "").trim() ? (
          <div style={{ ...appNeutralPanelStyle, marginBottom: "1rem" }}>
            <div className="flex flex-wrap justify-content-between align-items-center gap-2">
              <div>
                <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: "0.25rem" }}>Meeting link</div>
                <div style={appMutedTextStyle}>{String(selectedDemoSlot?.meetingLink || "").trim()}</div>
              </div>
              <Button
                label="Open Link"
                {...adminButtonProps}
                onClick={() => window.open(String(selectedDemoSlot?.meetingLink || "").trim(), "_blank", "noopener,noreferrer")}
              />
            </div>
          </div>
        ) : null}
        <div style={appDataTableWrapperStyle}>
          <DataTable
            value={Array.isArray(selectedDemoSlot?.registrations) ? selectedDemoSlot.registrations : []}
            className="p-datatable-sm p-datatable-striped"
            emptyMessage="No registrations for this slot yet."
          >
            <Column field="fullName" header="Name" />
            <Column field="email" header="Email" />
            <Column field="status" header="Status" body={(data) => String(data?.status || "").toUpperCase()} />
            <Column field="createdAt" header="Registered" body={(data) => data?.createdAt ? new Date(data.createdAt).toLocaleString() : "N/A"} />
            <Column field="cancelledAt" header="Cancelled" body={(data) => data?.cancelledAt ? new Date(data.cancelledAt).toLocaleString() : "N/A"} />
          </DataTable>
        </div>
      </Dialog>

      <Dialog
        header={renderSurfaceHeader(
          binderRuleDialogMode === "edit" ? "Edit Binder Rule" : binderRuleDialogMode === "version" ? "Create Binder Rule Version" : "Add Binder Rule",
          binderRuleDialogMode === "version" ? "Create a new active version and retire the previous one automatically." : "Manage binder rule metadata, citations, and effective dates.",
          "pi pi-book",
        )}
        visible={showBinderRuleDialog}
        modal
        onHide={() => !savingBinderRule && setShowBinderRuleDialog(false)}
        style={appDialogStyle}
        headerStyle={appDialogHeaderStyle}
        contentStyle={appDialogContentStyle}
        footer={renderDialogFooter({
          loading: savingBinderRule,
          onCancel: () => setShowBinderRuleDialog(false),
          onSubmit: onSaveBinderRule,
          submitLabel: binderRuleDialogMode === "edit" ? "Save Rule" : "Save Version",
        })}
      >
        <div className="grid">
          <div className="col-12 md:col-6">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Binder Type</label>
            <Dropdown
              value={binderRuleForm.binderType || selectedBinderRuleType}
              options={[
                { label: "Resident Binder", value: BinderType.RESIDENT },
                { label: "Home Binder", value: BinderType.HOME },
              ]}
              onChange={(e) => setBinderRuleForm((current) => ({ ...current, binderType: e.value, folderCode: getFolderOptionsForBinderType(e.value)[0]?.value || "" }))}
              optionLabel="label"
              optionValue="value"
              className="w-full"
              disabled={binderRuleDialogMode !== "create"}
            />
          </div>
          <div className="col-12 md:col-6">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Folder</label>
            <Dropdown
              value={binderRuleForm.folderCode || ""}
              options={getFolderOptionsForBinderType((binderRuleForm.binderType as BinderType) || selectedBinderRuleType)}
              onChange={(e) => setBinderRuleForm((current) => ({ ...current, folderCode: e.value }))}
              className="w-full"
            />
          </div>
          <div className="col-12">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Rule Title</label>
            <InputText value={binderRuleForm.title || ""} onChange={(e) => setBinderRuleForm((current) => ({ ...current, title: e.target.value }))} className="w-full" />
          </div>
          <div className="col-12">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Description</label>
            <InputTextarea rows={4} value={binderRuleForm.description || ""} onChange={(e) => setBinderRuleForm((current) => ({ ...current, description: e.target.value }))} className="w-full" />
          </div>
          <div className="col-12 md:col-6">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Citation</label>
            <InputText value={binderRuleForm.citation || ""} onChange={(e) => setBinderRuleForm((current) => ({ ...current, citation: e.target.value }))} className="w-full" />
          </div>
          <div className="col-12 md:col-6">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Source URL</label>
            <InputText value={binderRuleForm.sourceUrl || ""} onChange={(e) => setBinderRuleForm((current) => ({ ...current, sourceUrl: e.target.value }))} className="w-full" />
          </div>
          <div className="col-12 md:col-4">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Expected Documents</label>
            <InputText value={String(binderRuleForm.expectedDocumentCount || 1)} onChange={(e) => setBinderRuleForm((current) => ({ ...current, expectedDocumentCount: Number(e.target.value || 1) }))} className="w-full" />
          </div>
          <div className="col-12 md:col-4">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Effective From</label>
            <InputText type="date" value={binderRuleForm.effectiveFrom || ""} onChange={(e) => setBinderRuleForm((current) => ({ ...current, effectiveFrom: e.target.value }))} className="w-full" />
          </div>
          <div className="col-12 md:col-4">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Effective To</label>
            <InputText type="date" value={binderRuleForm.effectiveTo || ""} onChange={(e) => setBinderRuleForm((current) => ({ ...current, effectiveTo: e.target.value || undefined }))} className="w-full" />
          </div>
        </div>
      </Dialog>

      <Dialog
        header={renderSurfaceHeader(
          selectedBinderRuleSource?.title ? `${selectedBinderRuleSource.title} Snapshots` : "Binder Rule Snapshots",
          "Review fetched source snapshots and inspect the stored normalized content used for change detection.",
          "pi pi-history",
        )}
        visible={showBinderRuleSnapshotDialog}
        modal
        onHide={() => {
          setShowBinderRuleSnapshotDialog(false);
          setSelectedBinderRuleSnapshot(null);
        }}
        style={appDialogStyle}
        headerStyle={appDialogHeaderStyle}
        contentStyle={appDialogContentStyle}
      >
        <div className="flex flex-column gap-3">
          <div style={appDataTableWrapperStyle}>
            <DataTable value={binderRuleSnapshots} className="p-datatable-sm p-datatable-striped" loading={binderRuleSnapshotsLoading} emptyMessage="No snapshots captured for this source yet.">
              <Column field="createdAt" header="Captured" body={(data) => data.createdAt ? new Date(data.createdAt).toLocaleString() : "N/A"} />
              <Column field="effectiveDate" header="Effective Date" body={(data) => data.effectiveDate || "Not detected"} />
              <Column field="contentHash" header="Hash" body={(data) => String(data.contentHash || "").slice(0, 12) || "N/A"} />
              <Column field="changeDetected" header="Change" body={(data) => data.changeDetected ? "Yes" : "No"} />
              <Column field="aiSummaryStatus" header="AI" body={(data) => data.aiSummaryStatus || "not_needed"} />
              <Column
                header="Actions"
                body={(data: BinderRuleSnapshot) => (
                  <Button label="View Content" {...adminButtonProps} size="small" onClick={() => void onViewBinderRuleSnapshot(data.snapshotId!)} />
                )}
              />
            </DataTable>
          </div>

          {selectedBinderRuleSnapshotLoading ? (
            <div className="flex justify-content-center">
              <ProgressSpinner style={{ width: "3rem", height: "3rem" }} />
            </div>
          ) : selectedBinderRuleSnapshot ? (
            <div className="grid">
              <div className="col-12 lg:col-6">
                <div style={{ ...appNeutralPanelStyle, height: "100%" }}>
                  <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: "0.75rem" }}>Snapshot Metadata</div>
                  <div className="flex flex-column gap-2" style={appMutedTextStyle}>
                    <div><strong>Detected title:</strong> {selectedBinderRuleSnapshot.detectedTitle || "Not detected"}</div>
                    <div><strong>Effective date:</strong> {selectedBinderRuleSnapshot.effectiveDate || "Not detected"}</div>
                    <div><strong>Content hash:</strong> {selectedBinderRuleSnapshot.contentHash || "N/A"}</div>
                    <div><strong>HTML length:</strong> {selectedBinderRuleSnapshot.htmlLength || 0}</div>
                    <div><strong>Normalized text length:</strong> {selectedBinderRuleSnapshot.normalizedTextLength || 0}</div>
                    <div><strong>AI status:</strong> {selectedBinderRuleSnapshot.aiSummaryStatus || "not_needed"}</div>
                  </div>
                </div>
              </div>
              <div className="col-12 lg:col-6">
                <div style={{ ...appAccentPanelStyle, height: "100%" }}>
                  <div style={{ fontWeight: 700, color: "#9a3412", marginBottom: "0.75rem" }}>AI Summary</div>
                  <div style={{ whiteSpace: "pre-wrap", ...appMutedTextStyle }}>
                    {selectedBinderRuleSnapshot.aiSummary || "No AI summary was stored for this snapshot."}
                  </div>
                </div>
              </div>
              <div className="col-12">
                <label className="block mb-2" style={{ fontWeight: 600 }}>Normalized Text</label>
                <InputTextarea value={selectedBinderRuleSnapshot.normalizedText || ""} rows={14} className="w-full" readOnly autoResize={false} />
              </div>
            </div>
          ) : (
            <div style={appMutedTextStyle}>Choose a snapshot to inspect its stored content.</div>
          )}
        </div>
      </Dialog>

      <Dialog
        header={renderSurfaceHeader(
          binderRuleSourceForm.sourceId ? "Edit Binder Rule Source" : "Add Binder Rule Source",
          "Manage the official WAC or DSHS source pages used for binder rule monitoring.",
          "pi pi-globe",
        )}
        visible={showBinderRuleSourceDialog}
        modal
        onHide={() => !savingBinderRuleSource && setShowBinderRuleSourceDialog(false)}
        style={appDialogStyle}
        headerStyle={appDialogHeaderStyle}
        contentStyle={appDialogContentStyle}
        footer={renderDialogFooter({
          loading: savingBinderRuleSource,
          onCancel: () => setShowBinderRuleSourceDialog(false),
          onSubmit: onSaveBinderRuleSource,
          submitLabel: binderRuleSourceForm.sourceId ? "Save Source" : "Add Source",
        })}
      >
        <div className="grid">
          <div className="col-12 md:col-6">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Binder Type</label>
            <Dropdown
              value={binderRuleSourceForm.binderType || selectedBinderRuleType}
              options={[
                { label: "Resident Binder", value: BinderType.RESIDENT },
                { label: "Home Binder", value: BinderType.HOME },
              ]}
              onChange={(e) => setBinderRuleSourceForm((current) => ({ ...current, binderType: e.value }))}
              optionLabel="label"
              optionValue="value"
              className="w-full"
            />
          </div>
          <div className="col-12 md:col-6">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Source Type</label>
            <Dropdown
              value={binderRuleSourceForm.sourceType || "WAC"}
              options={[
                { label: "WAC", value: "WAC" },
                { label: "DSHS Guidance", value: "DSHS_GUIDANCE" },
                { label: "Other", value: "OTHER" },
              ]}
              onChange={(e) => setBinderRuleSourceForm((current) => ({ ...current, sourceType: e.value }))}
              optionLabel="label"
              optionValue="value"
              className="w-full"
            />
          </div>
          <div className="col-12">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Source Title</label>
            <InputText value={binderRuleSourceForm.title || ""} onChange={(e) => setBinderRuleSourceForm((current) => ({ ...current, title: e.target.value }))} className="w-full" />
          </div>
          <div className="col-12 md:col-6">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Citation</label>
            <InputText value={binderRuleSourceForm.citation || ""} onChange={(e) => setBinderRuleSourceForm((current) => ({ ...current, citation: e.target.value }))} className="w-full" />
          </div>
          <div className="col-12 md:col-6">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Status</label>
            <Dropdown
              value={binderRuleSourceForm.status || "active"}
              options={[
                { label: "Active", value: "active" },
                { label: "Paused", value: "paused" },
              ]}
              onChange={(e) => setBinderRuleSourceForm((current) => ({ ...current, status: e.value }))}
              optionLabel="label"
              optionValue="value"
              className="w-full"
            />
          </div>
          <div className="col-12">
            <label className="block mb-2" style={{ fontWeight: 600 }}>Source URL</label>
            <InputText value={binderRuleSourceForm.sourceUrl || ""} onChange={(e) => setBinderRuleSourceForm((current) => ({ ...current, sourceUrl: e.target.value }))} className="w-full" />
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={showAdminUserHomesDialog}
        modal
        header={renderSurfaceHeader(
          "Selected User Homes",
          `Homes attached to ${selectedAdminUserEmail || "the selected user"}.`,
          "pi pi-home",
        )}
        style={appWideDialogStyle}
        headerStyle={appDialogHeaderStyle}
        contentStyle={appDialogContentStyle}
        onHide={() => {
          if (!adminUserHomeDetailsLoading) {
            setShowAdminUserHomesDialog(false);
          }
        }}
      >
        {adminUserHomeDetailsLoading ? (
          <div className="flex justify-content-center p-3">
            <ProgressSpinner style={{ width: "3rem", height: "3rem" }} />
          </div>
        ) : (
          <div style={appDataTableWrapperStyle}>
            <DataTable value={adminUserHomeDetails} className="p-datatable-sm p-datatable-striped" emptyMessage="No active homes found for this user.">
              <Column field="businessName" header="Home Name" />
              <Column field="formattedAddress" header="Address" />
              <Column field="residents" header="Residents" />
            </DataTable>
          </div>
        )}
      </Dialog>

      <Dialog
        visible={Boolean(selectedCustomerFeedback)}
        modal
        style={appWideDialogStyle}
        header={renderSurfaceHeader(
          selectedCustomerFeedback ? `Feedback · ${customerFeedbackTypeLabel(selectedCustomerFeedback)}` : "Feedback",
          selectedCustomerFeedback ? `Submitted by ${selectedCustomerFeedback.createdBy || "Unknown user"}.` : "",
          "pi pi-comments",
        )}
        headerStyle={appDialogHeaderStyle}
        contentStyle={appDialogContentStyle}
        onHide={() => setSelectedCustomerFeedback(null)}
        footer={(
          <div className="flex justify-content-end gap-2">
            <Button type="button" label="Close" text rounded onClick={() => setSelectedCustomerFeedback(null)} />
            <Button type="button" label="Send Reply" icon="pi pi-send" severity="warning" rounded loading={customerFeedbackReplyLoading} disabled={!customerFeedbackReply.trim()} onClick={() => void submitAdminCustomerFeedbackReply()} />
          </div>
        )}
      >
        <div className="flex flex-column gap-3">
          <div className="flex gap-2 flex-wrap">
            <Tag value={customerFeedbackTypeLabel(selectedCustomerFeedback)} severity="info" rounded />
            <Tag value={String(selectedCustomerFeedback?.status || "NEW").replace(/_/g, " ")} severity="warning" rounded />
            <Tag value={`${Number(selectedCustomerFeedback?.messageCount || customerFeedbackMessages.length || 0)} message${Number(selectedCustomerFeedback?.messageCount || customerFeedbackMessages.length || 0) === 1 ? "" : "s"}`} severity="secondary" rounded />
          </div>
          <div style={{ maxHeight: "28rem", overflowY: "auto" }}>
            {customerFeedbackMessagesLoading ? <div style={appMutedTextStyle}>Loading feedback history...</div> : customerFeedbackMessages.map((item: any) => (
              <div key={item.messageId} className="mb-3" style={{ border: "1px solid #e2e8f0", borderRadius: "12px", padding: "0.85rem", background: item.senderRole === ROLE_TYPE_ADMIN ? "#eff6ff" : "#fff7ed" }}>
                <div className="flex justify-content-between gap-2 flex-wrap" style={{ fontSize: "0.8rem", color: "#475569" }}>
                  <strong>{item.senderRole === ROLE_TYPE_ADMIN ? "You / Admin" : item.senderName || "User"}</strong>
                  <span>{formatCustomerFeedbackDate(item.createdAt)}</span>
                </div>
                <div className="mt-2" style={{ whiteSpace: "pre-wrap", color: "#0f172a" }}>{item.message}</div>
                {item.emailNotification?.status && item.emailNotification.status !== "not_required" ? <div className="mt-2" style={{ fontSize: "0.75rem", color: item.emailNotification.status === "sent" ? "#166534" : "#b91c1c" }}>Email: {item.emailNotification.status}{item.emailNotification.error ? ` · ${item.emailNotification.error}` : ""}</div> : null}
              </div>
            ))}
          </div>
          <InputTextarea value={customerFeedbackReply} onChange={(event) => setCustomerFeedbackReply(event.target.value)} rows={5} maxLength={4000} autoResize placeholder="Write a reply to the user..." className="w-full" />
        </div>
      </Dialog>
    </div>
  );
};

export default AdminPage;
